import i18nFactory from '@yandex-int/i18n';
import { ApolloQueryResult } from 'apollo-client';
import { FetchResult } from 'apollo-link';
import { compact, get, some, values } from 'lodash';
import * as React from 'react';
import { FileWithPreview } from 'react-dropzone';
import { Epic, ofType } from 'redux-observable';
import { concat, EMPTY, forkJoin, from, Observable, of } from 'rxjs';
import {
    catchError,
    debounceTime,
    map,
    mergeMap,
    switchMap,
    takeUntil
} from 'rxjs/operators';

import { Action } from '../../actions';
import {
    CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS,
    ChangeCopiedDisplayConditionsTooltipStatus,
    changeCopiedDisplayConditionsTooltipStatus,
    COPY_KEYWORDS_TO_CLIPBOARD,
    CopyKeywordsToClipboard,
    ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS,
    ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS,
    OnChangeOpenStateDisplayConditions,
    onErrorLoadKeywordsAndRetargetingDisplayConditions,
    onLoadKeywordsAndRetargetingDisplayConditions,
    OnStartLoadKeywordsAndRetargetingDisplayConditions,
    onStartLoadKeywordsAndRetargetingDisplayConditions
} from '../../actions/banners-edit/banner-edit-display-conditions';
import {
    UPLOAD_AD_BANNER_IMAGES,
    UPLOAD_BANNER_IMAGE_CREATIVE_BY_LINK,
    uploadAdBannerImages,
    UploadAdBannerImages,
    UploadBannerImageCreativeByLink,
    VALIDATE_AD_BANNER_IMAGES,
    ValidateAdBannerImages
} from '../../actions/banners-edit/banner-image';
import {
    CHECK_BANNER_SITELINK_HREF_STATUS,
    checkBannerSitelinkHrefStatus,
    CheckBannerSitelinkHrefStatus,
    clearSiteLinks,
    createSiteLinksDraftData,
    SAVE_SITE_LINKS,
    SaveSiteLinks,
    showSiteLinksErrors,
    UPDATE_DRAFT_SITE_LINKS,
    UPDATE_PROTOCOL_DRAFT_SITE_LINKS,
    UpdateDraftSiteLinks,
    UpdateProtocolDraftSiteLinks,
    UpdateSiteLinkHrefStatus,
    updateSiteLinkHrefStatus
} from '../../actions/banners-edit/banner-sitelinks';
import {
    addImagesToNewBanners,
    bannerImageRemove,
    CANCEL_UPLOAD_BANNER_IMAGE,
    CANCEL_UPLOAD_IMAGE_CREATIVE,
    closeImagesGallery,
    resetBannerImageCreativeMode,
    SELECT_IMAGE_CANVAS_IDS,
    SelectImageCanvasIds,
    SHOW_BANNER_IMAGES_UPLOAD_ERROR,
    SHOW_IMAGE_GALLERY,
    showBannerImageCreativeUploadError,
    showBannerImagesUploadError,
    ShowBannerImagesUploadError,
    showBannerImageUploadError,
    ShowImageGallery,
    showImageGalleryError,
    UPDATE_BANNER_IMAGE_BY_GALLERY,
    updateBannerCanvasCreative,
    updateBannerImage,
    UpdateBannerImageByGallery,
    updateBannerImageByGallery,
    updateBannerImageByLink,
    updateImageEditor,
    updateImagesForGalleryEdit,
    UPLOAD_BANNER_IMAGE,
    UPLOAD_BANNER_IMAGE_BY_LINK,
    UploadBannerImage,
    UploadBannerImageByLink,
    VALIDATE_BANNER_IMAGE_FROM_GALLERY,
    ValidateBannerImageFromGallery
} from '../../actions/banners-edit/banner-text-image';
import {
    onOpenMassActionsSiteLinksEditor,
    openMassActionsBulkCpmImageCreativeReplacementEditor,
    openMassActionsBulkImageCreativeReplacementEditor,
    openMassActionsBulkImageReplacementEditor,
    openMassActionsCallouts,
    openMassActionsCounters,
    openMassActionsLinkBulkPathReplacementEditor,
    openMassActionsLinkBulkReplacementEditor,
    openMassActionsLinkDisplayedBulkReplacementEditor,
    openMassActionsPixel,
    openMassActionsTextBulkReplacementEditor,
    openMassActionsTrackingParametersBulkReplacementEditor,
    openMassActionsTurbolandingBulkReplacementEditorAction,
    openMassActionsVideoBulkReplacementEditorAction,
    openMassActionsVideoCreativeBulkReplacementEditorAction,
    updateMassActionsImageCreative
} from '../../actions/banners-edit/banners-edit-mass-actions';
import {
    saveCallouts,
    updateCalloutsList
} from '../../actions/banners-edit/callouts';
import {
    BannerContactsActions,
    CHANGE_MAIN_LINK_PROTOCOL,
    ChangeMainLinkProtocol,
    CHECK_BANNER_HREF_STATUS,
    CheckBannerHrefStatus,
    checkBannerHrefStatus,
    showBannersContactsValidationError,
    UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN,
    UPDATE_HREF_BANNER_CONTACTS_FOR_USER,
    UpdateBannerContactsForUserDomain,
    updateBannerDisplayDomain,
    updateBannerHrefStatus,
    UpdateHrefBannerContactsForUser
} from '../../actions/banners-edit/contacts';
import {
    GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS,
    GetBannnerForEditModerationRejectReasons,
    setBannerForEditModerationRejectReasonsError,
    updateBannerForEditModerationRejectReasons
} from '../../actions/banners-edit/cpm-banner';
import { updateBannersOrganizationIds } from '../../actions/banners-edit/organization';
import {
    FETCH_PERFORMANCE_CREATIVES_START,
    fetchPerformanceCreativesError,
    fetchPerformanceCreativesStart,
    FetchPerformanceCreativesStartAction,
    fetchPerformanceCreativesSuccess,
    LEAVE_PERFORMANCE_BANNER_CREATION,
    LeavePerformanceBannerCreation,
    PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME,
    setVisiblePerformanceChooseCreativesModal
} from '../../actions/banners-edit/performanceCreatives';
import {
    VALIDATE_BANNER_PRICE,
    ValidateBannerPrice,
    validateBannerPriceSuccess
} from '../../actions/banners-edit/price';
import {
    FETCH_RECOMMENDATIONS_FOR_BANNERS_EDIT,
    fetchRecommendationsForBannersEdit,
    FetchRecommendationsForBannersEditAction,
    OPEN_RECOMMENDATIONS_MODAL_FOR_BANNERS_EDIT,
    OpenRecommendationsModalForBannersEditAction,
    updateRecommendationsForBannersEdit
} from '../../actions/banners-edit/recommendations';
import {
    GET_TURBOLANDING_INFO_FOR_SITELINK,
    GetTurbolandingInfoForSitelink,
    updateTurbolandingForSitelink
} from '../../actions/banners-edit/turbolanding';
import { openBannersPricesPopup } from '../../actions/banners-prices';
import {
    addNewTextBanners,
    CANCEL_BANNERS,
    CHANGE_BANNER_TYPE_ATTEMPT,
    changeBannerType,
    ChangeBannerTypeAttempt,
    CHECK_PROMOCODES_AND_PREPARE_BANNERS,
    CLEAR_BANNERS,
    ClearBanners,
    clearVisitingCardForEditBanners,
    COPY_BANNER,
    CopyBanner,
    CREATE_NEW_TEXT_BANNER,
    createNewCpmBanner,
    createNewMcBanner,
    createNewTextBanner,
    CreateNewTextBannerAction,
    GET_BANNERS_AUTO_GENERATED_VIDEO,
    GET_BANNERS_FOR_EDIT,
    GET_BASE_INFO_FOR_BANNER_CREATION,
    GetBannersAutoGeneratedVideo,
    getBannersAutoGeneratedVideo,
    GetBannersForEdit,
    GetBaseInfoForBannerCreation,
    HANDLE_BANNERS_EDIT_MASS_ACTIONS,
    HandleBannersEditMassActions,
    LEAVE_BANNERS_EDIT,
    LeaveBannersEdit,
    ON_ADD_NEW_TEXT_BANNER,
    OnAddNewTextBanner,
    PREPARE_BANNERS_BEFORE_SAVING,
    prepareBannersBeforeSaving,
    resetBannersEdit,
    SAVE_BANNERS,
    SAVE_VISITING_CARD_FOR_EDIT_BANNER,
    saveBanners,
    saveBannersSuccess,
    SaveVisitingCardForEditBanner,
    ShowBannerEditRequestError,
    showBannerEditRequestError,
    showBannerEditSummaryError,
    showInvalidBannersPromocodes,
    UPDATE_BANNERS_EDIT_BASE_INFO_DATA,
    updateBannersAutoGeneratedVideo,
    UpdateBannersEditBaseInfoData,
    updateBannersEditBaseInfoData,
    updateBannersEditGroupDataForPerformanceCreation,
    updateBannersForEdit,
    updateLastAddedVCardIds,
    updateVCardsForEdit
} from '../../actions/bannersEdit';
import {
    changeLocation,
    changeLocationHard,
    dummyAction,
    updateMetroStations,
    updateRegions
} from '../../actions/common';
import {
    massUpdateBannerCreativeData,
    setCreativeData,
    UPDATE_BANNER_CREATIVE_ID,
    updateBannerCreativeData,
    UpdateBannerCreativeId
} from '../../actions/creative';
import { NoticeType, showNoticeMessage } from '../../actions/grid-screen';
import {
    copyOrganizationEditor,
    initOrganizationsEditors
} from '../../actions/organizationsEditor';
import { setRecommendationsModalDataAction } from '../../actions/recommendations-modal';
import {
    GET_TURBOLANDING_INFO,
    GetTurbolandingInfo,
    showTurbolandingInfoError,
    updateTurbolanding,
    updateTurbolandings
} from '../../actions/turbolandings';
import {
    bannerVideoRemove,
    closeVideoConstructor,
    ON_CLOSE_VIDEO_CONSTRUCTOR,
    OnCloseVideoConstructor,
    UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID,
    UPDATE_BANNER_VIDEO_CREATIVE_ID,
    UpdateBannerCpcVideoCreativeId,
    UpdateBannerVideoCreativeId,
    updateBannerVideoData,
    updateVideos
} from '../../actions/video';
import {
    clearVCard,
    FETCH_VCARD_METRO_STATION,
    FetchVCardMetroStation,
    GET_VCARDS_FOR_BANNERS_EDIT,
    getVCardsForBannersEdit,
    GetVCardsForBannersEdit,
    updateVCardMetroStationInfo
} from '../../actions/visitingCardEditor';
import { ImageGalleryType } from '../../components/ImageGallery/ImageGallery';
import { SiteLinkField } from '../../components/SiteLink/SiteLink';
import {
    BANNERS_IN_GROUP_LIMIT,
    DEFAULT_CREATIVES_LIMIT,
    DEFAULT_CREATIVES_OFFSET
} from '../../constants';
import {
    getBannerImageFromApiHashFormat,
    getTextBannerImageFromUploadResponse,
    mapAdsGroupEditRecommendationsToQueryResponse,
    mapGeneratedVideoGroupApiFormat,
    mapGroupsDataToBannerVideoFormat,
    mapPerformanceCreatives,
    mapPreviewVideoApiData,
    mapVideoGroupsToBannerFormat
} from '../../mappers/banners-edit/api-data-mappers';
import { mapBannersSiteLinksToApiFormat } from '../../mappers/banners-edit/sitelinks-mappers';
import {
    mapVCardToApiFormat,
    mapVisitingCardEditorValueToValue
} from '../../mappers/banners-edit/state-data-mappers/state-data-mappers';
import { getValueFromApiFormat } from '../../mappers/common/common';
import {
    mapBannerModerationRejectReasonsFromApiFormat,
    mapModerationEmailContactFromApiFormat
} from '../../mappers/moderation';
import {
    EntityType,
    mapBannersToOrganizationEditorParams,
    mapEntityIdToEditorKey
} from '../../mappers/organization/organization';
import { isGroupSupportsRecommendationsOnEditBannerPage } from '../../mappers/recommendation';
import { awaitCommonData } from '../../operators';
import {
    selectEditableBannerTypes,
    selectEditableImageAdsCount,
    selectEditableMcBannerCount
} from '../../selectors/bannerEdit/banner';
import { selectEditedBannerImageSize } from '../../selectors/bannerEdit/imageEditor';
import { selectBannerImageFromGallery } from '../../selectors/bannerEdit/imageGallery';
import { selectBannersInvalidPromocodes } from '../../selectors/bannerEdit/promocodes';
import { getBannerModalRecommendations } from '../../selectors/bannerEdit/recommendations';
import {
    selectVisitingCardEditorMetroStations,
    selectVisitingCardEditorValue
} from '../../selectors/visitingCardEditor/visitingCardEditor';
import { alert } from '../../service/Alert/Alert';
import {
    mapUploadImagesErrorsToNames,
    validateContacts,
    validateSiteLinks
} from '../../service/BannerEditErrors/BannerEditErrors';
import { getNotReadyToSaveBannersParams } from '../../service/BannerEditErrors/ErrorsTextMapper/ErrorsTextMapper';
import {
    getBannersNotReadyToSave,
    NotReadyBanner
} from '../../service/BannerEditValidation/helpers';
import { ImagesAdValidator } from '../../service/BannerEditValidation/ImagesAdValidator';
import {
    generateNewBannerId,
    getBannerEditPageItemEditorId,
    getBannersForSave,
    getBannersToDelete,
    getCollapsedSiteLinks,
    getEditBannerHrefValidateText,
    getGroupedBannersIdsByOpenCard,
    getGroupedBannersIdsForVisitingCard,
    getOnVideoPreviewClose,
    getTextBannersIds,
    getVCardsIds,
    HrefValidationStatuses,
    splitBannersOnNewAndEdited,
    splitCpmBannersByTypes,
    splitMcBannersByTypes,
    splitSmartBannersByTypes
} from '../../service/BannerHelpers/BannerHelpers';
import {
    getFullHref,
    validateImageCreativeItemsBySizeDuplicates
} from '../../service/BannersEditMassActionsHelpers/BannersEditMassActionsHelpers';
import { BannersIdsForBannersEditHelpers } from '../../service/BannersIdsForBannersEditHelpers';
import { copyTextToClipboard } from '../../service/Clipboard/Clipboard';
import { confirm } from '../../service/Confirm/Confirm';
import { ApiMethodExecutingError } from '../../service/Errors';
import {
    getUploadingImagesHash,
    isImageHasSize
} from '../../service/ImageHelpers/ImageHelpers';
import { pluralizeWord } from '../../service/Pluralize/Pluralize';
import { RegionsHelpers } from '../../service/RegionsHelpers/RegionsHelpers';
import { scrollToElementById } from '../../service/ScrollHelpers';
import { EpicDeps } from '../../service/StoreFactory';
import { UrlHelpers, UrlSearchParams } from '../../service/UrlHelpers';
import { getVisitingCardMetroStationName } from '../../service/VisitingCardEditorHelpers/VisitingCardEditorHelpers';
import {
    BannerId,
    ImageGalleryErrorsTypes,
    ImageItem,
    SaveBannersResult
} from '../../typings/banners';
import {
    bannerHasDisplayConditions,
    EditedBanner,
    EditedBannerTypeCpmBanner,
    EditedBannerTypeText,
    getEditedBannerMassSaveActions,
    getEditedBannerWithFullContacts,
    getEditedBannerWithImage,
    getEditedBannerWithSitelinks,
    InvalidBannerPromocodes,
    MassActionId,
    PerformanceModalType
} from '../../typings/bannersEditState';
import {
    ErrorResponseType,
    ValidationErrorsSet,
    ValidationResultItem
} from '../../typings/common';
import {
    AdvType,
    AdvTypeClient,
    BannerImageForEdit,
    BannerImageType,
    CampaignsCalcTypeFilter,
    CampaignType,
    CopyTooltipStatus
} from '../../typings/domain';
import { DnaEpic } from '../../typings/epic';
import {
    AddSitelinkSets,
    AddVCards,
    GdAddSitelinkSetsInput,
    GdAddVcardsInput,
    TurbolandingQuery,
    validateAdPrice
} from '../../typings/graphql-grid';
import { GridScreenUrlSearchQueryParams } from '../../typings/grid';
import { BannersEditMassActionItemType } from '../../typings/groups';
import { OrganizationEditorParams } from '../../typings/organizations';
import { RecommendationsModalState } from '../../typings/recommendations';
import { State } from '../../typings/state';
import { getExternalReasonsContent } from '../grid-screen/grid-screen';

import {
    getBannerPricePromiseErrorActions,
    getBannerPricePromiseValidateActions,
    getSiteLinksPromiseErrorActions,
    getSiteLinksPromiseSaveActions,
    getVCardsPromiseErrorActions,
    getVCardsPromiseSaveActions
} from './banners-edit-save-helper/banners-edit-save-helper';
import * as keyset from './bannersEdit.i18n';

const i18n = i18nFactory(keyset);

const updateBannersContactsForUserDomainEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$
        .ofType(UPDATE_BANNER_CONTACTS_FOR_USER_DOMAIN)
        .debounceTime(500)
        .mergeMap(
            (action: UpdateBannerContactsForUserDomain): Observable<Action> => {
                const { bannerId } = action;
                const {
                    contactsForUser: {
                        href: { value },
                        hrefProtocol
                    }
                } = action;

                const href = UrlHelpers.deleteProtocol(value);

                if (href.length === 0) {
                    return Observable.empty();
                }

                if (!UrlHelpers.isDomainValid(hrefProtocol + href)) {
                    return Observable.of(
                        updateBannerHrefStatus(
                            bannerId,
                            false,
                            getEditBannerHrefValidateText(
                                HrefValidationStatuses.INVALID_DOMAIN_VALUE
                            )
                        )
                    );
                } else {
                    return Observable.of(
                        checkBannerHrefStatus(
                            bannerId,
                            hrefProtocol + href,
                            true
                        )
                    );
                }
            }
        );
};

const updateBannersContactsForUserEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(UPDATE_HREF_BANNER_CONTACTS_FOR_USER),
        debounceTime(500),
        mergeMap(
            (
                action: UpdateHrefBannerContactsForUser
            ): Observable<
                BannerContactsActions | ShowBannerEditRequestError
            > => {
                const { bannerId, hrefValue } = action;
                const banner = getEditedBannerWithFullContacts(
                    store$.value.editBanners.banners[bannerId]
                );

                if (!banner) {
                    return Observable.empty();
                }

                const { hrefProtocol } = banner.contacts;

                const href = UrlHelpers.deleteProtocol(hrefValue);

                if (href.length === 0) {
                    return EMPTY;
                }

                if (!UrlHelpers.isUrlValid(hrefProtocol + href)) {
                    return of(
                        updateBannerHrefStatus(
                            bannerId,
                            false,
                            getEditBannerHrefValidateText(
                                HrefValidationStatuses.INVALID_VALUE
                            )
                        )
                    );
                } else {
                    return of(
                        checkBannerHrefStatus(
                            bannerId,
                            getFullHref(href, hrefProtocol),
                            true
                        )
                    );
                }
            }
        )
    );
};

const updateLinkProtocolBannersContactsForUserEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(CHANGE_MAIN_LINK_PROTOCOL),
        mergeMap(
            (
                action: ChangeMainLinkProtocol
            ): Observable<
                BannerContactsActions | ShowBannerEditRequestError
            > => {
                const { bannerId } = action;
                const hrefProtocol = action.value;

                const banner = getEditedBannerWithFullContacts(
                    store$.value.editBanners.banners[bannerId]
                );
                if (!banner) {
                    return EMPTY;
                }

                const href = UrlHelpers.deleteProtocol(banner.contacts.href);

                if (href.length === 0) {
                    return EMPTY;
                }

                if (!UrlHelpers.isUrlValid(hrefProtocol + href)) {
                    return of(
                        updateBannerHrefStatus(
                            bannerId,
                            false,
                            getEditBannerHrefValidateText(
                                HrefValidationStatuses.INVALID_VALUE
                            )
                        )
                    );
                } else {
                    return of(
                        checkBannerHrefStatus(
                            bannerId,
                            getFullHref(href, hrefProtocol),
                            false
                        )
                    );
                }
            }
        )
    );
};

const copyOrganizationBannerEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$.pipe(
        ofType(COPY_BANNER),
        map((action: CopyBanner) => {
            return copyOrganizationEditor(
                mapEntityIdToEditorKey(action.bannerId, EntityType.banner),
                mapEntityIdToEditorKey(action.newBannerId, EntityType.banner)
            );
        })
    );
};

const scrollToDuplicateBannerEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$.pipe(
        ofType(COPY_BANNER),
        mergeMap((action: CopyBanner) => {
            scrollToElementById(action.newBannerId);

            return EMPTY;
        })
    );
};

const clearOrganizationsBannersEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$.pipe(
        ofType(CLEAR_BANNERS),
        map((action: ClearBanners) => {
            const organizationEditorsParams: OrganizationEditorParams[] = Object.keys(
                action.bannersToClear
            ).map((bannerId: BannerId) => ({
                editorKey: mapEntityIdToEditorKey(bannerId, EntityType.banner)
            }));

            return initOrganizationsEditors(organizationEditorsParams);
        })
    );
};

const checkBannerHrefStatusEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) =>
    action$.pipe(
        ofType(CHECK_BANNER_HREF_STATUS),
        mergeMap(
            (action: CheckBannerHrefStatus): Observable<Action> => {
                const { login } = store$.value.commonData;

                return from(
                    deps.restApiManager.checkMassUrl(login, [action.href])
                ).pipe(
                    mergeMap(
                        ({
                            check_results = [],
                            validation_errors = []
                        }): Observable<Action> => {
                            const hrefValidationError =
                                (check_results[0] && check_results[0].error) ||
                                (validation_errors[0] &&
                                    validation_errors[0].code);

                            if (hrefValidationError) {
                                return of(
                                    updateBannerHrefStatus(
                                        action.bannerId,
                                        false,
                                        getEditBannerHrefValidateText(
                                            HrefValidationStatuses[
                                                hrefValidationError
                                            ]
                                        )
                                    )
                                );
                            }

                            if (
                                action.isHrefChanged &&
                                check_results[0].domain
                            ) {
                                return concat(
                                    of(
                                        updateBannerHrefStatus(
                                            action.bannerId,
                                            true,
                                            ''
                                        )
                                    ),
                                    of(
                                        updateBannerDisplayDomain(
                                            action.bannerId,
                                            check_results[0].domain
                                        )
                                    )
                                );
                            }

                            return of(
                                updateBannerHrefStatus(
                                    action.bannerId,
                                    true,
                                    ''
                                )
                            );
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return of(showBannerEditRequestError(error));
                        }
                    )
                );
            }
        )
    );

const updateDraftSiteLinksEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(UPDATE_DRAFT_SITE_LINKS),
        debounceTime(500),
        mergeMap(
            (
                action: UpdateDraftSiteLinks
            ): Observable<
                UpdateSiteLinkHrefStatus | CheckBannerSitelinkHrefStatus
            > => {
                const { bannerId, index, value, field } = action;
                const items =
                    store$.value.siteLinksEditor.data[action.bannerId].items;
                const href = UrlHelpers.deleteProtocol(String(value));
                const protocol =
                    UrlHelpers.extractProtocol(String(value)) ||
                    items[index].protocol;

                if (field !== SiteLinkField.link || href.length === 0) {
                    return EMPTY;
                }

                if (!UrlHelpers.isUrlValid(protocol + href)) {
                    return of(
                        updateSiteLinkHrefStatus(
                            bannerId,
                            index,
                            false,
                            getEditBannerHrefValidateText(
                                HrefValidationStatuses.INVALID_VALUE
                            )
                        )
                    );
                } else {
                    return of(
                        checkBannerSitelinkHrefStatus(
                            bannerId,
                            index,
                            protocol + href
                        )
                    );
                }
            }
        )
    );
};

const checkBannerSitelinkHrefStatusEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) =>
    action$.pipe(
        ofType(CHECK_BANNER_SITELINK_HREF_STATUS),
        mergeMap(
            (action: CheckBannerSitelinkHrefStatus): Observable<Action> => {
                const { login } = store$.value.commonData;

                return from(
                    deps.restApiManager.checkMassUrl(login, [action.href])
                ).pipe(
                    mergeMap(
                        ({
                            check_results = [],
                            validation_errors = []
                        }): Observable<Action> => {
                            const hrefValidationError =
                                (check_results[0] && check_results[0].error) ||
                                (validation_errors[0] &&
                                    validation_errors[0].code);

                            if (hrefValidationError && action.href) {
                                return of(
                                    updateSiteLinkHrefStatus(
                                        action.bannerId,
                                        action.index,
                                        false,
                                        getEditBannerHrefValidateText(
                                            HrefValidationStatuses[
                                                hrefValidationError
                                            ]
                                        )
                                    )
                                );
                            }

                            return of(
                                updateSiteLinkHrefStatus(
                                    action.bannerId,
                                    action.index,
                                    true,
                                    ''
                                )
                            );
                        }
                    ),
                    catchError(
                        (): Observable<Action> => {
                            return of(
                                updateSiteLinkHrefStatus(
                                    action.bannerId,
                                    action.index,
                                    false,
                                    getEditBannerHrefValidateText(
                                        HrefValidationStatuses.HTTP_ERROR
                                    )
                                )
                            );
                        }
                    )
                );
            }
        )
    );

const getBaseInfoForBannerCreationEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(GET_BASE_INFO_FOR_BANNER_CREATION),
        awaitCommonData(action$, store$),
        mergeMap(
            (action: GetBaseInfoForBannerCreation): Observable<Action> => {
                const {
                    commonData: {
                        login,
                        client: { autoVideo }
                    }
                } = store$.value;
                if (action.campaignsIds.length === 0) {
                    const url = UrlHelpers.getBannersListUrl();

                    return of(
                        changeLocation(
                            url,
                            {
                                ulogin: login
                            },
                            false
                        )
                    );
                }

                const generateVideoRequest = autoVideo
                    ? deps.bannersMutationExecutor.getGeneratedTextVideo({
                          adGroupIds: action.groupIds
                      })
                    : Promise.resolve();

                return forkJoin(
                    deps.bannersDataProvider.getBaseInfoForBannerCreation(
                        action.login,
                        action.campaignsIds,
                        action.groupIds
                    ),
                    deps.bannersDataProvider.getMetroStations(),
                    generateVideoRequest,
                    RegionsHelpers.fetchRegions()
                ).pipe(
                    switchMap(
                        ([
                            baseInfoData,
                            metroStations,
                            videoResult,
                            regionsResult
                        ]): Observable<Action> => {
                            if (
                                selectEditableBannerTypes(store$.value)
                                    .length === 0
                            ) {
                                const url = UrlHelpers.getBannersListUrl();

                                return of(
                                    changeLocation(
                                        url,
                                        {
                                            ulogin: login
                                        },
                                        false
                                    )
                                );
                            }

                            if (
                                autoVideo &&
                                videoResult &&
                                videoResult.generateVideoAddition &&
                                videoResult.generateVideoAddition.length !==
                                    0 &&
                                videoResult.generateVideoAddition[0]
                            ) {
                                const video =
                                    videoResult.generateVideoAddition[0];

                                baseInfoData = {
                                    ...baseInfoData,
                                    video: {
                                        data: {
                                            id: video.creativeId,
                                            name: video.name,
                                            previewUrl: video.previewUrl
                                        }
                                    }
                                };
                            }
                            // после того, как заполнится базовая информация (константы, уточнения и т.д.)
                            // сработает ещё один эпик, который будет разруливать - какой баннер создавать
                            return from([
                                updateBannersEditBaseInfoData(
                                    baseInfoData,
                                    login
                                ),
                                updateMetroStations(metroStations),
                                updateCalloutsList(baseInfoData.callouts),
                                updateRegions(regionsResult)
                            ]);
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return of(showBannerEditRequestError(error));
                        }
                    )
                );
            }
        )
    );
};

const getModerationRejectReasons: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(GET_BANNER_FOR_EDIT_MODERATION_REJECT_REASONS),
        mergeMap(
            ({
                bid
            }: GetBannnerForEditModerationRejectReasons): Observable<
                Action
            > => {
                const state = store$.value;
                const { login } = state.commonData;

                return Observable.fromPromise(
                    deps.entitiesDataProvider.getCalloutsIds(login)
                )
                    .mergeMap(
                        (calloutsIds): Observable<Action> => {
                            return Observable.fromPromise(
                                deps.restApiManager.getModerationRejectReasons(
                                    bid,
                                    calloutsIds
                                )
                            )
                                .map(data => {
                                    const items = mapBannerModerationRejectReasonsFromApiFormat(
                                        data
                                    );

                                    const contactEmail = mapModerationEmailContactFromApiFormat(
                                        data,
                                        state.commonData.operator.isAgency
                                    );

                                    const params = {
                                        items,
                                        contactEmail
                                    };
                                    return params;
                                })
                                .mergeMap(params => {
                                    return getExternalReasonsContent(
                                        params,
                                        deps
                                    );
                                })
                                .map(params => {
                                    return updateBannerForEditModerationRejectReasons(
                                        bid,
                                        params
                                    );
                                })
                                .catch(() => {
                                    return Observable.of(
                                        setBannerForEditModerationRejectReasonsError(
                                            bid,
                                            i18n(
                                                'fetch-moderation-reject-reasons-error'
                                            )
                                        )
                                    );
                                });
                        }
                    )
                    .catch(
                        (): Observable<Action> => {
                            return Observable.of(
                                setBannerForEditModerationRejectReasonsError(
                                    bid,
                                    i18n(
                                        'fetch-moderation-reject-reasons-error'
                                    )
                                )
                            );
                        }
                    );
            }
        )
    );
};

const createNewBannerEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(UPDATE_BANNERS_EDIT_BASE_INFO_DATA),
        mergeMap(
            (action: UpdateBannersEditBaseInfoData): Observable<Action> => {
                const group = action.data.group;
                const campaign = action.data.campaign;
                const video = action.data.video;
                const { login } = store$.value.commonData;
                const { vCardsIds } = store$.value.editBanners;
                const vCardsAction = [];

                if (!group) {
                    throw new Error('group must be specified');
                }

                if (!campaign) {
                    throw new Error('campaign must be specified');
                }

                const vCardId = vCardsIds[campaign.id];

                if (vCardId !== undefined) {
                    vCardsAction.push(
                        getVCardsForBannersEdit(login, [vCardId])
                    );
                }

                switch (campaign.type) {
                    case CampaignType.TEXT:
                        // для текстового баннера обычным образом создаём новый баннер
                        // не используем акшн добавления ТГО, потому что считаем, что нет ещё никаких баннеров
                        // и страница находится в состоянии loading, в этом экшне ещё приедет PageStatus.LOADED
                        return from([
                            createNewTextBanner(
                                campaign,
                                group,
                                generateNewBannerId(campaign.id, group.id),
                                video
                            ),
                            ...vCardsAction
                        ]);
                    case CampaignType.PERFORMANCE:
                        // для смарт-баннеров сначала формируем информацию о группе, которая потом используется
                        // при выборе креативов в модалке, после этого вызываем модалку с креативами
                        return concat(
                            of(
                                updateBannersEditGroupDataForPerformanceCreation(
                                    campaign,
                                    group
                                )
                            ),
                            of(
                                setVisiblePerformanceChooseCreativesModal(
                                    true,
                                    {
                                        type: PerformanceModalType.ADDITION,
                                        campaignId: campaign.id,
                                        groupId: group.id
                                    }
                                )
                            )
                        );
                    case CampaignType.CPM_BANNER:
                        // для медийного баннера обычным образом создаём новый баннер
                        // не используем акшн добавления ТГО, потому что считаем, что нет ещё никаких баннеров
                        // и страница находится в состоянии loading, в этом экшне ещё приедет PageStatus.LOADED
                        const getRecommendationAction = isGroupSupportsRecommendationsOnEditBannerPage(
                            group.type
                        )
                            ? [
                                  fetchRecommendationsForBannersEdit(
                                      action.login,
                                      [campaign.id],
                                      [group.id]
                                  )
                              ]
                            : [];

                        return from([
                            createNewCpmBanner(
                                campaign,
                                group,
                                generateNewBannerId(campaign.id, group.id)
                            ),
                            ...getRecommendationAction
                        ]);

                    case CampaignType.MCBANNER:
                        return from([
                            createNewMcBanner(
                                campaign,
                                group,
                                generateNewBannerId(campaign.id, group.id)
                            )
                        ]);

                    default:
                        throw new Error(
                            `unsupported campaign type ${
                                campaign.type
                            } for create banner`
                        );
                }

                return EMPTY;
            }
        ),
        catchError(
            (error: ApiMethodExecutingError): Observable<Action> => {
                return of(showBannerEditRequestError(error));
            }
        )
    );
};

const getBannersForEditEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(GET_BANNERS_FOR_EDIT),
        awaitCommonData(action$, store$),
        mergeMap(
            (action: GetBannersForEdit): Observable<Action> => {
                const state = store$.value;
                const {
                    commonData: {
                        client: { autoVideo }
                    },
                    editBanners: { bannersIds = [], campaignsIds = [] }
                } = state;

                if (campaignsIds.length === 0) {
                    const url = UrlHelpers.getBannersListUrl();

                    return of(
                        changeLocation(
                            url,
                            {
                                ulogin: action.login
                            },
                            false
                        )
                    );
                }

                return forkJoin(
                    deps.bannersDataProvider.getBanners(
                        action.login,
                        bannersIds,
                        campaignsIds
                    ),
                    deps.bannersDataProvider.getMetroStations(),
                    RegionsHelpers.fetchRegions()
                ).pipe(
                    switchMap(
                        ([
                            bannersAndImageData,
                            metroResult,
                            regionsResult
                        ]): Observable<Action> => {
                            const {
                                bannersEditData,
                                imageEditData,
                                reqId
                            } = bannersAndImageData;

                            if (
                                selectEditableBannerTypes(store$.value)
                                    .length === 0
                            ) {
                                // надо убрать когда будем проверять на уровне роутера
                                const url = UrlHelpers.getBannersListUrl();

                                return of(
                                    changeLocation(
                                        url,
                                        {
                                            ulogin: action.login
                                        },
                                        false
                                    )
                                );
                            }

                            const vCardsIds = getVCardsIds(bannersEditData);

                            const { callouts, ...banners } = bannersEditData;

                            const organizations: OrganizationEditorParams[] = mapBannersToOrganizationEditorParams(
                                bannersEditData
                            );

                            const groupListValues = values(
                                bannersEditData.groupBannersList
                            );
                            const groupSupportsRecommendationIds = groupListValues
                                .filter(value =>
                                    isGroupSupportsRecommendationsOnEditBannerPage(
                                        value.type
                                    )
                                )
                                .map(group => group.groupId);
                            const getRecommendationAction = groupSupportsRecommendationIds.length
                                ? [
                                      fetchRecommendationsForBannersEdit(
                                          action.login,
                                          campaignsIds,
                                          groupSupportsRecommendationIds
                                      )
                                  ]
                                : [];

                            return from(
                                compact([
                                    updateImageEditor(imageEditData),
                                    setCreativeData(bannersEditData.creative),
                                    updateVideos(bannersEditData.video),
                                    updateBannersForEdit(banners, reqId),
                                    createSiteLinksDraftData(banners),
                                    updateCalloutsList(callouts),
                                    updateTurbolandings(
                                        bannersEditData.turbolandings
                                    ),
                                    updateLastAddedVCardIds(
                                        bannersEditData.vCardIds
                                    ),
                                    ...getRecommendationAction,
                                    updateMetroStations(metroResult),
                                    vCardsIds.length !== 0 &&
                                        getVCardsForBannersEdit(
                                            action.login,
                                            vCardsIds
                                        ),
                                    autoVideo &&
                                        getBannersAutoGeneratedVideo(
                                            Object.keys(
                                                bannersEditData.groupBannersList
                                            )
                                        ),
                                    updateRegions(regionsResult),
                                    initOrganizationsEditors(organizations)
                                ])
                            );
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return of(showBannerEditRequestError(error));
                        }
                    )
                );
            }
        )
    );
};

const fetchVCardMetroStationEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_VCARD_METRO_STATION),
        mergeMap(
            (action: FetchVCardMetroStation): Observable<Action> => {
                const { x, y, editorId } = action;
                const state = store$.value;

                return from(
                    deps.bannersDataProvider.getMetroByCoordinates(x, y)
                ).pipe(
                    map(
                        (data): Action => {
                            const { getMetroByCoordinates } = data;
                            const metroStations = selectVisitingCardEditorMetroStations(
                                state,
                                editorId
                            );

                            if (
                                metroStations &&
                                getMetroByCoordinates &&
                                getMetroByCoordinates.geoId
                            ) {
                                const geoId = String(
                                    getMetroByCoordinates.geoId
                                );
                                const metroStationName = metroStations.filter(
                                    station => station.val === geoId
                                )[0].text;

                                return updateVCardMetroStationInfo(
                                    geoId,
                                    metroStationName,
                                    editorId
                                );
                            }

                            return dummyAction;
                        }
                    ),
                    catchError(err => {
                        return EMPTY;
                    })
                );
            }
        )
    );
};

const getRecommendationsForBannersEditEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FETCH_RECOMMENDATIONS_FOR_BANNERS_EDIT),
        mergeMap(
            (
                action: FetchRecommendationsForBannersEditAction
            ): Observable<Action> => {
                return from(
                    deps.bannersDataProvider.getAdsGroupEditRecommendations(
                        action.login,
                        action.campainIds,
                        action.groupIds
                    )
                ).pipe(
                    map(
                        (data): Action => {
                            return updateRecommendationsForBannersEdit(
                                mapAdsGroupEditRecommendationsToQueryResponse(
                                    data
                                )
                            );
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return of(showBannerEditRequestError(error));
                        }
                    )
                );
            }
        )
    );
};

const getImagesForEdit: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(SHOW_IMAGE_GALLERY),
        mergeMap(
            (action: ShowImageGallery): Observable<Action> => {
                const state = store$.value;
                const { login } = state.commonData;
                const { bannerId, galleryType } = action;
                const banner = state.editBanners.banners[bannerId];
                let bannerType;
                let fixedSize;

                switch (galleryType) {
                    case ImageGalleryType.imageAd:
                        if (bannerId === MassActionId.bannersEdit) {
                            const mcBannerAdsCount = selectEditableMcBannerCount(
                                state
                            );
                            const imageAdsCount = selectEditableImageAdsCount(
                                state
                            );
                            if (imageAdsCount) {
                                bannerType = AdvType.IMAGE_AD;
                            } else if (mcBannerAdsCount) {
                                bannerType = AdvType.MCBANNER;
                            } else {
                                throw new Error(
                                    'unsupported bannerType for massaction show image gallery'
                                );
                            }
                        } else {
                            if (!banner) {
                                bannerType = AdvType.IMAGE_AD;
                            } else {
                                if (!banner.isNew) {
                                    fixedSize = selectEditedBannerImageSize(
                                        state,
                                        bannerId
                                    );
                                }
                                bannerType = banner.bannerType;
                            }
                        }
                        break;
                    case ImageGalleryType.textImageAd:
                        bannerType = AdvType.TEXT;
                        break;
                    default:
                        throw new Error(
                            `unsupported gallery type: ${galleryType}`
                        );
                }

                return from(
                    deps.bannersDataProvider.getImagesForGallery(
                        login,
                        bannerType,
                        fixedSize
                    )
                ).pipe(
                    mergeMap(
                        (data): Observable<Action> => {
                            if (data.length === 0) {
                                return of(
                                    showImageGalleryError(bannerId, [
                                        {
                                            code:
                                                ImageGalleryErrorsTypes.IMAGES_COUNT_NULL,
                                            path: '',
                                            params: null
                                        }
                                    ])
                                );
                            }
                            return of(
                                updateImagesForGalleryEdit(
                                    action.bannerId,
                                    data
                                )
                            );
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return of(
                                showImageGalleryError(
                                    bannerId,
                                    error.getType() !==
                                        ErrorResponseType.graphQL
                                        ? [
                                              {
                                                  code:
                                                      ImageGalleryErrorsTypes.INTERNAL_ERROR,
                                                  path: '',
                                                  params: null
                                              }
                                          ]
                                        : error.getErrors()
                                )
                            );
                        }
                    )
                );
            }
        )
    );
};

const updateBannerImagesFromGallery: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(UPDATE_BANNER_IMAGE_BY_GALLERY),
        mergeMap(
            (action: UpdateBannerImageByGallery): Array<Action> => {
                const state = store$.value;

                if (action.bannerId === MassActionId.bannersEdit) {
                    const { images = [] } = store$.value.imageEditor[
                        action.bannerId
                    ].imageGallery;
                    const newImagesHash = action.imagesHash[0];
                    const newImages: ImageItem[] = images.filter(
                        (image: ImageItem) => newImagesHash.includes(image.hash)
                    );

                    return [
                        updateMassActionsImageCreative(
                            MassActionId.bannersEdit,
                            newImages
                        )
                    ];
                }

                const banner = getEditedBannerWithImage(
                    store$.value.editBanners.banners[action.bannerId]
                );

                // этот случай достижим только для ГО объявлений в ТГО объявлениях или MC-баннерах
                if (banner && action.imagesHash.length > 1) {
                    const { images = [] } = store$.value.imageEditor[
                        action.bannerId
                    ].imageGallery;
                    const newImagesHash = action.imagesHash.slice(1);
                    const newImages: ImageItem[] = images.filter(
                        (image: ImageItem) => newImagesHash.includes(image.hash)
                    );
                    const groupId = banner.group.id;
                    const campaignId = banner.campaign.id;

                    const autoGeneratedVideo = mapGroupsDataToBannerVideoFormat(
                        state.editBanners.groupBannersList
                    );

                    let bannerType: AdvType;

                    switch (banner.campaign.type) {
                        case CampaignType.MCBANNER:
                            bannerType = AdvType.MCBANNER;
                            break;
                        case CampaignType.TEXT:
                        default:
                            bannerType = AdvType.IMAGE_AD;
                            break;
                    }

                    return [
                        addNewTextBanners(
                            newImages.map(image => ({
                                campaignId,
                                groupId,
                                bannerType,
                                bannerData: {
                                    id: generateNewBannerId(campaignId, groupId)
                                }
                            })),
                            autoGeneratedVideo
                        ),
                        addImagesToNewBanners(newImages)
                    ];
                }
                return [dummyAction];
            }
        )
    );
};

const getVCardsForEditEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(GET_VCARDS_FOR_BANNERS_EDIT),
        mergeMap(
            (action: GetVCardsForBannersEdit): Observable<Action> => {
                return from(
                    deps.bannersDataProvider.getVCards(
                        action.login,
                        action.vCardIds
                    )
                ).pipe(
                    mergeMap(
                        (data): Observable<Action> => {
                            const state = store$.value;
                            const {
                                commonData: { metroStations }
                            } = state;
                            // сначала собираем все полученные визитки и сопоставляем их по ключам
                            // потом обновялем стэйт
                            const vcardData = action.vCardIds.reduce(
                                (acc, vCardId) => {
                                    const currentVisitCard = data.data[vCardId];
                                    const {
                                        geoId,
                                        metroStationId
                                    } = currentVisitCard;
                                    // ВАЖНО! На бэке хранится тектовое представление станции метро
                                    // Однако, более точное название (а вдруг), хранится в результатах выполнения ручки на получение всех станций, там данные более актуальные
                                    // Если удалось вытащить такое имя - при отправке на бэк в мутации отправим уже более точную информацию
                                    const metroStationName = getVisitingCardMetroStationName(
                                        geoId,
                                        getValueFromApiFormat(metroStationId),
                                        metroStations
                                    );

                                    return {
                                        ...acc,
                                        [vCardId]: {
                                            ...currentVisitCard,
                                            metroStationName: metroStationName
                                                ? metroStationName
                                                : currentVisitCard.metroStationName
                                        }
                                    };
                                },
                                {}
                            );

                            return of(updateVCardsForEdit(vcardData));
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return of(showBannerEditRequestError(error));
                        }
                    )
                );
            }
        )
    );
};

const validateBannerPriceEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(VALIDATE_BANNER_PRICE),
        mergeMap(
            (action: ValidateBannerPrice): Observable<Action> => {
                const state = store$.value;
                const bannerPrices = action.bannerId.map(
                    id => state.bannersPriceEditor[id].bannerPrice
                );
                const workCurrency = state.editBanners.clientInfo.workCurrency;
                const isBannersPricesEmpty = !bannerPrices.some(item =>
                    Boolean(item.price)
                );

                if (isBannersPricesEmpty) {
                    return of(
                        validateBannerPriceSuccess(
                            action.bannerId,
                            workCurrency
                        )
                    );
                }

                return from(
                    deps.bannersDataProvider.validateBannerPrice(bannerPrices)
                ).pipe(
                    mergeMap(
                        (
                            result: ApolloQueryResult<validateAdPrice>
                        ): Observable<Action> => {
                            return concat(
                                of(
                                    ...getBannerPricePromiseValidateActions(
                                        action.bannerId,
                                        result,
                                        workCurrency
                                    )
                                )
                            );
                        }
                    ),
                    catchError(
                        (): Observable<Action> => {
                            return concat(
                                of(
                                    ...getBannerPricePromiseErrorActions(
                                        action.bannerId
                                    )
                                )
                            );
                        }
                    )
                );
            }
        )
    );
};

const updateBannerCreativeIdEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) =>
    action$.pipe(
        ofType(UPDATE_BANNER_VIDEO_CREATIVE_ID),
        mergeMap(
            (action: UpdateBannerVideoCreativeId): Observable<Action> => {
                const { login } = store$.value.commonData;

                return from(
                    deps.restApiManager.getVideoDataByCreativeIds(
                        [action.creativeId],
                        login
                    )
                ).pipe(
                    mergeMap(
                        (data): Observable<Action> => {
                            return of(
                                updateBannerVideoData(
                                    mapPreviewVideoApiData(data.result[0]),
                                    action.id
                                )
                            );
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return of(showBannerEditRequestError(error));
                        }
                    )
                );
            }
        )
    );

const updateBannerCpcCreativeIdEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) =>
    action$.pipe(
        ofType(UPDATE_BANNER_CPC_VIDEO_CREATIVE_ID),
        mergeMap(
            (action: UpdateBannerCpcVideoCreativeId): Observable<Action> => {
                const { login } = store$.value.commonData;

                return from(
                    deps.restApiManager.getVideoDataByCreativeIds(
                        [action.creativeId],
                        login
                    )
                ).pipe(
                    mergeMap(
                        (data): Observable<Action> => {
                            return of(
                                updateBannerVideoData(
                                    mapPreviewVideoApiData(data.result[0]),
                                    action.id
                                )
                            );
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return of(showBannerEditRequestError(error));
                        }
                    )
                );
            }
        )
    );

const onVideoCreativeCloseEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) =>
    action$.pipe(
        ofType(ON_CLOSE_VIDEO_CONSTRUCTOR),
        mergeMap(
            (action: OnCloseVideoConstructor): Observable<Action> => {
                return from(
                    confirm({
                        message: getOnVideoPreviewClose('video')
                    })
                ).pipe(
                    mergeMap(
                        (): Observable<Action> => {
                            return of(closeVideoConstructor(action.id));
                        }
                    ),
                    catchError(
                        (): Observable<Action> => Observable.of(dummyAction)
                    )
                );
            }
        )
    );

const getTurbolandingInfoEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(GET_TURBOLANDING_INFO),
        mergeMap(
            (action: GetTurbolandingInfo): Observable<Action> => {
                const state = store$.value;
                const {
                    commonData: { login }
                } = state;

                return from(
                    deps.turboDataProvider.getTurbolandings(login, [
                        +action.landingId
                    ])
                ).pipe(
                    mergeMap(
                        (
                            response: ApolloQueryResult<TurbolandingQuery>
                        ): Observable<Action> => {
                            const turbolanding = response.data.turbolandings[0];

                            return of(
                                updateTurbolanding({
                                    id: action.id,
                                    page: {
                                        landingId: String(action.landingId),
                                        name: get(turbolanding, 'name', ''),
                                        href: get(turbolanding, 'href', '')
                                    }
                                })
                            );
                        }
                    ),
                    catchError(
                        (error): Observable<Action> => {
                            return of(
                                showTurbolandingInfoError(action.id, error)
                            );
                        }
                    )
                );
            }
        )
    );
};

const getTurbolandingInfoForSitelinkEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) =>
    action$.pipe(
        ofType(GET_TURBOLANDING_INFO_FOR_SITELINK),
        mergeMap(
            (action: GetTurbolandingInfoForSitelink): Observable<Action> => {
                const state = store$.value;
                const {
                    commonData: { login },
                    siteLinksEditor
                } = state;

                return from(
                    deps.turboDataProvider.getTurbolandings(login, [
                        +action.landingId
                    ])
                ).pipe(
                    mergeMap(
                        (response): Observable<Action> => {
                            const turbolanding = response.data.turbolandings[0];
                            const index =
                                siteLinksEditor.data[action.bannerId]
                                    .currentSitelink;

                            return of(
                                updateTurbolandingForSitelink(
                                    action.bannerId,
                                    index,
                                    {
                                        landingId: action.landingId,
                                        name: get(turbolanding, 'name', ''),
                                        href: get(turbolanding, 'href', '')
                                    }
                                )
                            );
                        }
                    ),
                    catchError(
                        (error): Observable<Action> => {
                            return of(
                                showTurbolandingInfoError(
                                    action.bannerId,
                                    error
                                )
                            );
                        }
                    )
                );
            }
        )
    );

const leaveBannersEditEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$
) => {
    return action$.ofType(LEAVE_BANNERS_EDIT).mergeMap(
        (action: LeaveBannersEdit): Array<Action> | Observable<Action> => {
            const state = store$.value;

            const {
                editBanners,
                editInternalBanners,
                commonData: {
                    login,
                    fromOldInterface,
                    operatorFeatures,
                    accessRights
                },
                video,
                turbolandings,
                creative
            } = state;

            let cid;
            let banners = {};

            if (Object.keys(editBanners.banners).length > 0) {
                cid = editBanners.campaignsIds[0];
                banners = editBanners.banners;
            } else if (Object.keys(editInternalBanners.banners).length > 0) {
                cid = editInternalBanners.campaignsIds[0];
                banners = editInternalBanners.banners;
            }

            if (!cid) {
                throw new Error('не задан номер кампании');
            }

            const { location } = action;

            const {
                bannersToSave,
                smartBannersToSave,
                cpmBannersToSave
            } = getBannersForSave(
                banners,
                video,
                creative,
                turbolandings,
                operatorFeatures,
                accessRights
            );

            const { editedBanners, newBanners } = splitBannersOnNewAndEdited(
                bannersToSave
            );

            const { newSmartBanners } = splitSmartBannersByTypes(
                smartBannersToSave
            );

            const { editedCpmBanners, newCpmBanners } = splitCpmBannersByTypes(
                cpmBannersToSave
            );

            const bannersNotReadyToSave: NotReadyBanner[] = getBannersNotReadyToSave(
                state,
                bannersToSave
            );

            const isCampaignCpmBanner = Object.keys(cpmBannersToSave).length;

            let leavePage$: Array<Action>;

            if (fromOldInterface) {
                const queryParams: UrlSearchParams = {
                    cid: cid,
                    ulogin: login
                };

                if (
                    typeof location !== 'string' &&
                    location.query !== undefined
                ) {
                    queryParams.search_by = 'group';
                    queryParams.search_banner = location.query['groups-ids'];
                }

                leavePage$ = [
                    changeLocationHard(
                        UrlHelpers.getDirectLink('showCamp', queryParams)
                    ),
                    resetBannersEdit()
                ];
            } else {
                const calcType = isCampaignCpmBanner
                    ? CampaignsCalcTypeFilter.CPM
                    : CampaignsCalcTypeFilter.CPC;
                const typeLocation =
                    typeof location !== 'string'
                        ? location.query
                        : { ulogin: login };

                leavePage$ = [
                    changeLocation(
                        typeof location !== 'string'
                            ? location.pathname
                            : location,
                        {
                            ...typeLocation,
                            [GridScreenUrlSearchQueryParams.calcType]: calcType
                        },
                        typeof location !== 'string'
                    ),
                    resetBannersEdit()
                ];
            }

            const wasDataChanged =
                Object.keys(editedBanners).length !== 0 ||
                Object.keys(newBanners).length !== 0 ||
                Object.keys(newSmartBanners).length !== 0 ||
                Object.keys(editedCpmBanners).length !== 0 ||
                Object.keys(newCpmBanners).length !== 0;

            if (bannersNotReadyToSave.length) {
                return of(
                    showBannerEditSummaryError(
                        getNotReadyToSaveBannersParams(bannersNotReadyToSave)
                    )
                );
            }

            if (wasDataChanged && action.showConfirm) {
                return from(
                    confirm({
                        message: i18n('warning-about-changes')
                    })
                ).pipe(
                    mergeMap(
                        (): Array<Action> => {
                            return leavePage$;
                        }
                    ),
                    catchError((): Observable<Action> => EMPTY)
                );
            }

            return leavePage$;
        }
    );
};

const checkBannersPromocodesEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(CHECK_PROMOCODES_AND_PREPARE_BANNERS),
        map(
            (): Action => {
                const state = store$.value;
                const invalidPromocodes: InvalidBannerPromocodes = selectBannersInvalidPromocodes(
                    state
                );

                if (Object.keys(invalidPromocodes).length === 0) {
                    return prepareBannersBeforeSaving();
                } else {
                    return showInvalidBannersPromocodes(invalidPromocodes);
                }
            }
        )
    );
};

const openRecommendationsModalForBannersEditEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$.pipe(
        ofType(OPEN_RECOMMENDATIONS_MODAL_FOR_BANNERS_EDIT),
        map(
            (action: OpenRecommendationsModalForBannersEditAction): Action => {
                const state = store$.value;
                const modalData: RecommendationsModalState = getBannerModalRecommendations(
                    state,
                    action.id
                );

                return setRecommendationsModalDataAction(modalData);
            }
        )
    );
};

const saveBannersEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(SAVE_BANNERS),
        mergeMap(
            (): Observable<Action> => {
                const state = store$.value;
                const { login, fromOldInterface } = state.commonData;
                const {
                    editBanners: { banners, bannersIds, isNew, campaignsIds },
                    commonData,
                    imageEditor,
                    video,
                    creative,
                    turbolandings
                } = state;
                const {
                    bannersToSave,
                    smartBannersToSave,
                    cpmBannersToSave,
                    mcBannersToSave
                } = getBannersForSave(
                    banners,
                    video,
                    creative,
                    turbolandings,
                    commonData.operatorFeatures,
                    commonData.accessRights
                );
                const bannersToDelete = getBannersToDelete<EditedBanner>(
                    banners
                );
                let clientValidationActions: Observable<Action> = EMPTY;

                const {
                    editedBanners,
                    newBanners
                } = splitBannersOnNewAndEdited(bannersToSave);
                const {
                    editedSmartBanners,
                    newSmartBanners
                } = splitSmartBannersByTypes(smartBannersToSave);

                const {
                    editedCpmBanners,
                    newCpmBanners
                } = splitCpmBannersByTypes(cpmBannersToSave);

                const { editedMcBanners, newMcBanners } = splitMcBannersByTypes(
                    mcBannersToSave
                );

                const bannersNotReadyToSave: NotReadyBanner[] = [
                    ...getBannersNotReadyToSave(state, bannersToSave),
                    ...getBannersNotReadyToSave(state, cpmBannersToSave)
                ];

                const isCampaignCpmBanner = some(
                    banners,
                    banner =>
                        banner.campaign &&
                        banner.campaign.type === CampaignType.CPM_BANNER
                );

                let oldInterfaceSuccessAction: Action = dummyAction;

                if (fromOldInterface) {
                    const cid = campaignsIds[0];

                    if (cid === undefined) {
                        throw new Error('не задан номер кампании');
                    }

                    oldInterfaceSuccessAction = changeLocationHard(
                        UrlHelpers.getShowCampaignUrl(cid, login)
                    );
                }

                if (bannersNotReadyToSave.length) {
                    return of(
                        showBannerEditSummaryError(
                            getNotReadyToSaveBannersParams(
                                bannersNotReadyToSave
                            )
                        )
                    );
                }

                const contactsValidationResult: ValidationErrorsSet = validateContacts(
                    banners
                );
                const isContactsValidationEmpty =
                    Object.keys(contactsValidationResult).length === 0;

                if (!isContactsValidationEmpty) {
                    clientValidationActions = of(
                        showBannersContactsValidationError(
                            contactsValidationResult
                        )
                    );

                    // Удаляем те ключи, которые не прошли клиентскую валидацию
                    Object.keys(contactsValidationResult).forEach(key => {
                        delete editedBanners[key];
                        delete newBanners[key];
                        delete editedMcBanners[key];
                        delete newMcBanners[key];
                    });
                }

                if (
                    Object.keys(editedBanners).length === 0 &&
                    Object.keys(newBanners).length === 0 &&
                    Object.keys(newSmartBanners).length === 0 &&
                    Object.keys(editedSmartBanners).length === 0 &&
                    Object.keys(newCpmBanners).length === 0 &&
                    Object.keys(editedCpmBanners).length === 0 &&
                    Object.keys(newMcBanners).length === 0 &&
                    Object.keys(editedMcBanners).length === 0 &&
                    Object.keys(bannersToDelete).length === 0 &&
                    isContactsValidationEmpty
                ) {
                    if (fromOldInterface) {
                        return of(oldInterfaceSuccessAction);
                    } else {
                        // нет баннеров на сохранение
                        const url = UrlHelpers.getBannersListUrl();
                        return of(
                            changeLocation(
                                url,
                                {
                                    ulogin: login,
                                    [GridScreenUrlSearchQueryParams.calcType]: isCampaignCpmBanner
                                        ? CampaignsCalcTypeFilter.CPM
                                        : CampaignsCalcTypeFilter.CPC
                                },
                                false
                            )
                        );
                    }
                }

                return from(
                    deps.bannersMutationExecutor.saveAds(
                        {
                            add: newBanners,
                            update: editedBanners,
                            addSmartAds: newSmartBanners,
                            updateSmartAds: editedSmartBanners,
                            addCpmAds: newCpmBanners,
                            updateCpmAds: editedCpmBanners,
                            addMcBannerAds: newMcBanners,
                            updateMcBannerAds: editedMcBanners,
                            delete: bannersToDelete
                        },
                        login,
                        commonData,
                        imageEditor
                    )
                ).pipe(
                    mergeMap(
                        (result: SaveBannersResult): Observable<Action> => {
                            const {
                                added,
                                updated,
                                smartAdded,
                                smartUpdated,
                                cpmAdded,
                                cpmUpdated,
                                deleted,
                                mcBannerAdded,
                                mcBannerUpdated
                            } = result;

                            if (
                                added.errors.length ||
                                updated.errors.length ||
                                smartAdded.errors.length ||
                                smartUpdated.errors.length ||
                                cpmAdded.errors.length ||
                                cpmUpdated.errors.length ||
                                mcBannerAdded.errors.length ||
                                mcBannerUpdated.errors.length ||
                                deleted.errors.length ||
                                !isContactsValidationEmpty
                            ) {
                                if (added.banners.length) {
                                    BannersIdsForBannersEditHelpers.setCampAndBannerIds(
                                        login,
                                        [
                                            ...bannersIds,
                                            ...added.banners
                                                .filter(b => b !== null)
                                                .map(b => b!.id)
                                        ],
                                        isNew
                                    );
                                }

                                return concat(
                                    clientValidationActions,
                                    of(saveBannersSuccess(result))
                                );
                            }

                            if (fromOldInterface) {
                                return Observable.of(oldInterfaceSuccessAction);
                            } else {
                                const url = UrlHelpers.getBannersListUrl();

                                return of(
                                    changeLocation(
                                        url,
                                        {
                                            ulogin: login,
                                            [GridScreenUrlSearchQueryParams.calcType]: isCampaignCpmBanner
                                                ? CampaignsCalcTypeFilter.CPM
                                                : CampaignsCalcTypeFilter.CPC
                                        },
                                        false
                                    )
                                );
                            }
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<ShowBannerEditRequestError> => {
                            return Observable.of(
                                showBannerEditRequestError(error)
                            );
                        }
                    )
                );
            }
        )
    );
};

const uploadBannerImageEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(UPLOAD_BANNER_IMAGE),
        mergeMap(
            (action: UploadBannerImage): Observable<Action> => {
                const {
                    commonData: { login },
                    editBanners: { banners }
                } = store$.value;

                if (action.bannerId !== MassActionId.bannersEdit) {
                    const banner = getEditedBannerWithImage(
                        banners[action.bannerId]
                    );

                    if (!banner) {
                        return EMPTY;
                    }
                }

                const bannerImage =
                    store$.value.imageEditor[action.bannerId].image;

                return from(
                    deps.restApiManager.uploadAdBannerImage(
                        login,
                        AdvType.TEXT,
                        action.filesToUpload
                    )
                ).pipe(
                    mergeMap(
                        (response): Observable<Action> => {
                            if (
                                bannerImage.uploadingData ===
                                getUploadingImagesHash(action.filesToUpload)
                            ) {
                                const image = getTextBannerImageFromUploadResponse(
                                    response.result[0],
                                    BannerImageType.TEXT
                                );
                                return of(
                                    updateBannerImage(action.bannerId, image)
                                );
                            } else {
                                return EMPTY;
                            }
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            if (
                                bannerImage.uploadingData ===
                                getUploadingImagesHash(action.filesToUpload)
                            ) {
                                return of(
                                    showBannerImageUploadError(
                                        action.bannerId,
                                        error.getErrors()
                                    )
                                );
                            } else {
                                return EMPTY;
                            }
                        }
                    )
                );
            }
        )
    );
};

const saveSitelinksEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(SAVE_SITE_LINKS),
        mergeMap(
            (action: SaveSiteLinks): Observable<Action> => {
                const {
                    commonData: { login },
                    editBanners,
                    siteLinksEditor
                } = store$.value;
                const { banners } = editBanners;

                // схлопываем все сайтлинки до нормальной структуры
                const collapsedSiteLinks = action.bannerId.map(id =>
                    getCollapsedSiteLinks(siteLinksEditor.data[id].items)
                );

                const availableBanners: EditedBannerTypeText[] = action.bannerId.map(
                    (bannerId, index) => {
                        const banner = getEditedBannerWithSitelinks(
                            banners[bannerId]
                        );

                        if (!banner) {
                            return;
                        }

                        return {
                            ...banner,
                            sitelinks: {
                                ...banner.sitelinks,
                                items: collapsedSiteLinks[index]
                            }
                        };
                    }
                ) as EditedBannerTypeText[];

                if (!availableBanners.length) {
                    return EMPTY;
                }
                const availableSiteLinksData = action.bannerId.map(
                    (bannerId, index) => {
                        const siteLinks = siteLinksEditor.data[bannerId];

                        return {
                            ...siteLinks,
                            items: collapsedSiteLinks[index]
                        };
                    }
                );

                const validateSitelinksResult: ValidationResultItem[][] = validateSiteLinks(
                    availableBanners,
                    availableSiteLinksData,
                    action.bannerId,
                    editBanners
                );

                const isSiteLinksValidationEmpty = validateSitelinksResult.every(
                    item => item.length === 0
                );

                if (!isSiteLinksValidationEmpty) {
                    return of(
                        showSiteLinksErrors(
                            action.bannerId,
                            collapsedSiteLinks,
                            validateSitelinksResult
                        )
                    );
                }

                // пользователь может заполнить 3ую ссылку из 4ых и будет так
                //  [null, null, {...}, null] это нужно сохранить, чтобы потом смапить ошибки

                const newSiteLinks = mapBannersSiteLinksToApiFormat(
                    action.bannerId,
                    action.bannerId.reduce((acc, bannerId, index) => {
                        return {
                            ...acc,
                            [bannerId]: {
                                ...siteLinksEditor.data[bannerId],
                                items: collapsedSiteLinks[index]
                            }
                        };
                    }, {})
                );

                if (newSiteLinks.every(item => item.sitelinks.length === 0)) {
                    return of(clearSiteLinks(action.bannerId));
                }

                const requestData: GdAddSitelinkSetsInput = {
                    sitelinkSetsAddItems: newSiteLinks
                };

                return from(
                    deps.sitelinksMutationExecutor.addSitelinkSet(
                        requestData,
                        login
                    )
                ).pipe(
                    mergeMap(
                        (
                            response: FetchResult<AddSitelinkSets>
                        ): Observable<Action> =>
                            concat(
                                of(
                                    ...getSiteLinksPromiseSaveActions(
                                        action.bannerId,
                                        newSiteLinks,
                                        login,
                                        response,
                                        collapsedSiteLinks
                                    )
                                )
                            )
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return concat(
                                of(
                                    ...getSiteLinksPromiseErrorActions(
                                        error,
                                        action.bannerId,
                                        collapsedSiteLinks,
                                        newSiteLinks,
                                        login
                                    )
                                )
                            );
                        }
                    )
                );
            }
        )
    );
};

const uploadTextBannerImageByLinkEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) =>
    action$.pipe(
        ofType(UPLOAD_BANNER_IMAGE_BY_LINK),
        mergeMap(
            ({
                link,
                bannerId
            }: UploadBannerImageByLink): Observable<Action> => {
                const { login } = store$.value.commonData;
                const {
                    clientInfo: { clientId }
                } = store$.value.editBanners;

                return from(
                    deps.restApiManager.uploadBannerTextImageByLink(login, link)
                ).pipe(
                    mergeMap(
                        ({ result: { hash, name } }): Observable<Action> =>
                            of(
                                updateBannerImageByLink(
                                    getBannerImageFromApiHashFormat(
                                        hash,
                                        String(clientId)
                                    ),
                                    name,
                                    bannerId,
                                    true
                                )
                            )
                    ),
                    takeUntil(action$.ofType(CANCEL_UPLOAD_BANNER_IMAGE)),
                    catchError(
                        (error): Observable<Action> => {
                            const errors = error.getErrors();
                            const actionErrors =
                                errors.length === 0
                                    ? [
                                          {
                                              code: '',
                                              path: '',
                                              params: null
                                          }
                                      ]
                                    : errors;

                            return of(
                                showBannerImageCreativeUploadError(
                                    bannerId,
                                    actionErrors,
                                    true
                                )
                            );
                        }
                    )
                );
            }
        )
    );

const cancelBannersEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store,
    deps
) => {
    return action$.pipe(
        ofType(CANCEL_BANNERS),
        map(
            (): Action => {
                const {
                    editBanners,
                    commonData: { login, fromOldInterface }
                } = store.value;

                if (fromOldInterface) {
                    const cid = editBanners.campaignsIds[0];

                    if (cid === undefined) {
                        throw new Error('не задан номер кампании');
                    }

                    return changeLocationHard(
                        UrlHelpers.getShowCampaignUrl(cid, login)
                    );
                } else {
                    const url = UrlHelpers.getBannersListUrl();
                    const isCampaignCpmBanner = some(
                        editBanners.banners,
                        banner =>
                            banner.campaign.type === CampaignType.CPM_BANNER
                    );

                    return changeLocation(
                        url,
                        {
                            ulogin: login,
                            [GridScreenUrlSearchQueryParams.calcType]: isCampaignCpmBanner
                                ? CampaignsCalcTypeFilter.CPM
                                : CampaignsCalcTypeFilter.CPC
                        },
                        false
                    );
                }
            }
        )
    );
};

const uploadAdBannerImageByLinkEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) =>
    action$.pipe(
        ofType(UPLOAD_BANNER_IMAGE_CREATIVE_BY_LINK),
        mergeMap(
            ({
                bannerId
            }: UploadBannerImageCreativeByLink): Observable<Action> => {
                const state = store$.value;
                const {
                    commonData: { login }
                } = state;

                const bannerImage = state.imageEditor[bannerId].image;
                const banner = state.editBanners.banners[bannerId];
                const link = state.imageEditor[bannerId].imageUploadingLink;

                let bannerType;
                if (bannerId === MassActionId.bannersEdit) {
                    const mcBannerAdsCount = selectEditableMcBannerCount(state);
                    const imageAdsCount = selectEditableImageAdsCount(state);
                    if (imageAdsCount) {
                        bannerType = AdvType.IMAGE_AD;
                    } else if (mcBannerAdsCount) {
                        bannerType = AdvType.MCBANNER;
                    } else {
                        throw new Error(
                            'unsupported bannerType for massaction upload banner image by link'
                        );
                    }
                } else {
                    bannerType = banner.bannerType;
                }

                return from(
                    deps.restApiManager.uploadBannerAdImageByLink(
                        login,
                        bannerType,
                        link
                    )
                ).pipe(
                    takeUntil(action$.ofType(CANCEL_UPLOAD_IMAGE_CREATIVE)),
                    mergeMap(
                        ({ result }): Observable<Action> => {
                            const fixedSize = bannerImage.fixedSize;

                            if (
                                fixedSize &&
                                bannerId !== MassActionId.bannersEdit &&
                                !store$.value.editBanners.banners[bannerId]
                                    .isNew &&
                                !isImageHasSize(fixedSize, result)
                            ) {
                                return of(
                                    showBannerImageCreativeUploadError(
                                        bannerId,
                                        [
                                            {
                                                path: '',
                                                code:
                                                    'BannerDefectIds.Gen.IMAGE_SIZE_MODIFICATION',
                                                params: {
                                                    size: `${fixedSize.width}x${
                                                        fixedSize.height
                                                    }`
                                                }
                                            }
                                        ]
                                    )
                                );
                            }

                            const uploadImage = getTextBannerImageFromUploadResponse(
                                result,
                                BannerImageType.BANNER
                            );

                            const uploadImageCreativesActions: Array<Action> = [
                                updateBannerImage(bannerId, uploadImage)
                            ];

                            if (bannerId === MassActionId.bannersEdit) {
                                uploadImageCreativesActions.push(
                                    updateMassActionsImageCreative(
                                        MassActionId.bannersEdit,
                                        [uploadImage]
                                    )
                                );
                            }

                            return of(...uploadImageCreativesActions);
                        }
                    ),
                    catchError(
                        (error): Observable<Action> => {
                            const errors = error.getErrors();
                            const actionErrors =
                                errors.length === 0
                                    ? [
                                          {
                                              code: '',
                                              path: '',
                                              params: null
                                          }
                                      ]
                                    : errors;

                            return of(
                                showBannerImageCreativeUploadError(
                                    bannerId,
                                    actionErrors,
                                    true
                                )
                            );
                        }
                    )
                );
            }
        )
    );

const validateAdBannerImagesEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(VALIDATE_AD_BANNER_IMAGES),
        map(
            ({
                files,
                bannerId,
                bannerType,
                isLocalUploading
            }: ValidateAdBannerImages): Action => {
                const state = store$.value;
                const accepted: FileWithPreview[] = [];
                const declined: Record<string, ValidationResultItem[]> = {};

                if (files.length > 0) {
                    if (bannerId !== MassActionId.bannersEdit) {
                        // проверяем, можем ли мы добавить несколько картинок
                        const groupId =
                            state.editBanners.banners[bannerId].group.id;
                        const bannersInGroup =
                            state.editBanners.groupBannersList[groupId]
                                .bannersTotal;
                        const bannersLeft =
                            BANNERS_IN_GROUP_LIMIT - bannersInGroup + 1;
                        if (files.length > bannersLeft) {
                            showCanLoadWarning(bannersLeft);
                            return dummyAction;
                        }
                    }

                    // если файлы есть, пытаемся их провалидировать на клиенте
                    files.forEach(file => {
                        const errors = ImagesAdValidator.validate(
                            file,
                            {},
                            state.editBanners
                        );
                        errors.length
                            ? (declined[file.name] = errors)
                            : accepted.push(file);
                    });
                    // Если есть валидные, то грузим, невалидные передаем тоже, чтобы склеить с серверной валидацией и показать списком
                    if (accepted.length) {
                        return uploadAdBannerImages(
                            bannerId,
                            accepted,
                            declined,
                            bannerType,
                            isLocalUploading
                        );
                    } else {
                        // Если валидных нет, и ошибка только в одном файле, показываем ошибку прям в баннере
                        if (Object.keys(declined).length === 1) {
                            return showBannerImageCreativeUploadError(
                                bannerId,
                                declined[Object.keys(declined)[0]]
                            );
                        } else {
                            return showBannerImagesUploadError(
                                bannerId,
                                declined
                            );
                        }
                    }
                } else {
                    return dummyAction;
                }
            }
        )
    );
};

const validateBannerImageFromGalleryEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(VALIDATE_BANNER_IMAGE_FROM_GALLERY),
        mergeMap(
            ({
                imagesHash,
                bannerId
            }: ValidateBannerImageFromGallery): Observable<Action> => {
                const state = store$.value;

                if (imagesHash.length > 0) {
                    const banner = state.editBanners.banners[bannerId];

                    if (bannerId !== MassActionId.bannersEdit) {
                        // проверяем, можем ли мы добавить несколько картинок
                        const groupId = banner.group.id;
                        const bannersInGroup =
                            state.editBanners.groupBannersList[groupId]
                                .bannersTotal;
                        // Первое объявление обновляется, остальные - добавляются
                        const bannersLeft =
                            BANNERS_IN_GROUP_LIMIT - bannersInGroup + 1;

                        if (imagesHash.length > bannersLeft) {
                            showCanLoadWarning(bannersLeft);

                            return EMPTY;
                        }
                    }

                    // Выбрать из стейта размер первой картинки - он должен совпадать с размером редактируемой
                    const selectedImages = selectBannerImageFromGallery(
                        state,
                        bannerId
                    );
                    const { fixedSize } = state.imageEditor[bannerId].image;

                    if (
                        fixedSize &&
                        !state.editBanners.banners[bannerId].isNew
                    ) {
                        const sizeErrors = ImagesAdValidator.checkSize(
                            selectedImages[0],
                            fixedSize
                        );

                        if (sizeErrors.length > 0) {
                            if (banner.bannerType === AdvType.IMAGE_AD) {
                                return of(
                                    showBannerImageCreativeUploadError(
                                        bannerId,
                                        sizeErrors
                                    ),
                                    closeImagesGallery(bannerId)
                                );
                            } else {
                                return of(
                                    showBannerImageUploadError(
                                        bannerId,
                                        sizeErrors
                                    ),
                                    closeImagesGallery(bannerId)
                                );
                            }
                        }
                    }

                    // Значит загружаем новую картинку или все нормально
                    return of(
                        updateBannerImageByGallery(
                            bannerId,
                            imagesHash,
                            BannerImageType.BANNER
                        )
                    );
                } else {
                    return EMPTY;
                }
            }
        )
    );
};

const showCanLoadWarning = (limit: number) => {
    alert({
        children: pluralizeWord(
            [
                i18n('one-image-can-load', {
                    count: limit
                }),
                i18n('some-image-can-load', {
                    count: limit
                }),
                i18n('many-image-can-load', {
                    count: limit
                })
            ],
            limit
        ),
        buttonText: i18n('not-loaded-files-button')
    });
};

const uploadAdBannerImagesEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(UPLOAD_AD_BANNER_IMAGES),
        mergeMap(
            ({
                filesToUpload,
                filesInvalid,
                bannerId,
                bannerType
            }: UploadAdBannerImages): Observable<Action> => {
                const {
                    commonData: { login },
                    editBanners: { banners, groupBannersList }
                } = store$.value;

                const banner = banners[bannerId];
                const bannerImage = store$.value.imageEditor[bannerId].image;

                return from(
                    deps.restApiManager.uploadAdBannerImage(
                        login,
                        bannerType,
                        filesToUpload as FileWithPreview[]
                    )
                ).pipe(
                    mergeMap(
                        (response): Array<Action> => {
                            const uploadedImages: BannerImageForEdit[] = response.result
                                .filter(image => Boolean(image))
                                .map(image =>
                                    getTextBannerImageFromUploadResponse(
                                        image,
                                        BannerImageType.BANNER
                                    )
                                );

                            const uploadingData = bannerImage.uploadingData;
                            let errorsMap: Record<
                                string,
                                ValidationResultItem[]
                            > = { ...filesInvalid };

                            // убеждаемся, что получили ответ на последний отправленный запрос (пользователь мог "отменить" предыдущий)
                            if (
                                uploadingData ===
                                getUploadingImagesHash(
                                    filesToUpload as FileWithPreview[]
                                )
                            ) {
                                // Если загружали одну картинку, и есть ограничение по размерам, то проверяем
                                if (
                                    uploadedImages.length === 1 &&
                                    bannerImage.fixedSize &&
                                    bannerId !== MassActionId.bannersEdit &&
                                    !banner.isNew
                                ) {
                                    const sizeErrors = ImagesAdValidator.checkSize(
                                        uploadedImages[0],
                                        bannerImage.fixedSize
                                    );
                                    if (sizeErrors.length > 0) {
                                        return [
                                            showBannerImageCreativeUploadError(
                                                bannerId,
                                                sizeErrors
                                            )
                                        ];
                                    }
                                }

                                if (
                                    response.validation_result &&
                                    response.validation_result.errors
                                ) {
                                    errorsMap = {
                                        ...errorsMap,
                                        ...mapUploadImagesErrorsToNames(
                                            filesToUpload,
                                            response.validation_result
                                                .errors as ValidationResultItem[]
                                        )
                                    };
                                }

                                const autoGeneratedVideo = mapGroupsDataToBannerVideoFormat(
                                    groupBannersList
                                );

                                const massActions = [
                                    updateMassActionsImageCreative(
                                        MassActionId.bannersEdit,
                                        uploadedImages
                                    )
                                ];

                                const newBannersActions =
                                    uploadedImages.length > 1
                                        ? [
                                              addNewTextBanners(
                                                  uploadedImages
                                                      .slice(1)
                                                      .map(() => ({
                                                          campaignId:
                                                              banner.campaign
                                                                  .id,
                                                          groupId:
                                                              banner.group.id,
                                                          bannerType,
                                                          bannerData: {
                                                              id: generateNewBannerId(
                                                                  banner
                                                                      .campaign
                                                                      .id,
                                                                  banner.group
                                                                      .id
                                                              )
                                                          }
                                                      })),
                                                  autoGeneratedVideo
                                              ),
                                              addImagesToNewBanners(
                                                  uploadedImages.slice(1)
                                              )
                                          ]
                                        : [dummyAction];

                                return [
                                    // для текущего баннера меняем картинку
                                    updateBannerImage(
                                        bannerId,
                                        uploadedImages[0]
                                    ),
                                    // для остальных картинок создаем баннеры
                                    ...(bannerId === MassActionId.bannersEdit
                                        ? massActions
                                        : newBannersActions),
                                    // если есть какие-нибудь ошибки то показываем их
                                    Object.keys(errorsMap).length > 0
                                        ? showBannerImagesUploadError(
                                              bannerId,
                                              errorsMap
                                          )
                                        : dummyAction
                                ];
                            } else {
                                return [dummyAction];
                            }
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            const errorsFromApi = get(
                                error,
                                'errors',
                                undefined
                            );

                            if (!errorsFromApi) {
                                const actionErrors = [
                                    {
                                        code: '',
                                        path: '',
                                        params: null
                                    }
                                ];

                                return of(
                                    showBannerImageCreativeUploadError(
                                        bannerId,
                                        actionErrors
                                    )
                                );
                            }

                            const errors = error.getErrors();

                            if (errors.length > 1) {
                                return of(
                                    resetBannerImageCreativeMode(bannerId),
                                    showBannerImagesUploadError(
                                        bannerId,
                                        mapUploadImagesErrorsToNames(
                                            filesToUpload,
                                            errors
                                        )
                                    )
                                );
                            }

                            return of(
                                showBannerImageCreativeUploadError(
                                    bannerId,
                                    errors
                                )
                            );
                        }
                    )
                );
            }
        )
    );
};

const showBannerImagesErrorEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(SHOW_BANNER_IMAGES_UPLOAD_ERROR),
        map((action: ShowBannerImagesUploadError) => {
            alert({
                title: i18n('not-loaded-files-title'),
                children: React.createElement('ul', {
                    children: Object.keys(action.errors).map(name =>
                        React.createElement('li', {
                            children: `${name} - ${action.errors[name]
                                .map(e => e.text)
                                .join(', ')}`
                        })
                    )
                }),
                buttonText: i18n('not-loaded-files-button')
            });

            return dummyAction;
        })
    );
};

const updateCpmBannerCreativeIdEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(UPDATE_BANNER_CREATIVE_ID),
        mergeMap(
            ({ ids, id }: UpdateBannerCreativeId): Observable<Action> => {
                const state = store$.value;
                const { login } = state.commonData;
                const {
                    editBanners: { groupBannersList }
                } = state;

                const { pageType } = state.creative[id];

                return from(
                    deps.bannersDataProvider.getCreativesForEdit(
                        login,
                        ids,
                        pageType
                    )
                ).pipe(
                    mergeMap(
                        (
                            creatives: BannerImageForEdit[]
                        ): Observable<Action> => {
                            if (id === MassActionId.bannersEdit) {
                                return concat(
                                    of(
                                        massUpdateBannerCreativeData(
                                            id,
                                            creatives
                                        )
                                    )
                                );
                            }

                            const banner = state.editBanners.banners[
                                id
                            ] as EditedBannerTypeCpmBanner;
                            const groupId = banner.group.id;
                            const campaignId = banner.campaign.id;

                            const creativesForNewBanners = creatives.slice(1);
                            const autoGeneratedVideo = mapGroupsDataToBannerVideoFormat(
                                groupBannersList
                            );

                            return concat(
                                of(updateBannerCreativeData(id, creatives[0])),
                                of(
                                    addNewTextBanners(
                                        creativesForNewBanners.map(
                                            creative => ({
                                                campaignId,
                                                groupId,
                                                bannerType: banner.bannerType,
                                                bannerData: {
                                                    creative: {
                                                        data: {
                                                            id:
                                                                creative.id ||
                                                                '',
                                                            name:
                                                                creative.name ||
                                                                '',
                                                            previewUrl:
                                                                creative.url ||
                                                                '',
                                                            width:
                                                                creative.width,
                                                            height:
                                                                creative.height,
                                                            isAdaptive: Boolean(
                                                                creative.isAdaptive
                                                            ),
                                                            type:
                                                                creative.creativeType
                                                        }
                                                    },
                                                    id: generateNewBannerId(
                                                        banner.campaign.id,
                                                        banner.group.id
                                                    )
                                                }
                                            })
                                        ),
                                        autoGeneratedVideo
                                    )
                                )
                            );
                        }
                    ),
                    catchError(
                        (
                            error: ApiMethodExecutingError
                        ): Observable<Action> => {
                            return of(showBannerEditRequestError(error));
                        }
                    )
                );
            }
        )
    );
};

const getImageCanvasForEdit: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(SELECT_IMAGE_CANVAS_IDS),
        mergeMap(
            ({ ids, bannerId }: SelectImageCanvasIds): Observable<Action> => {
                const state = store$.value;
                const { login } = state.commonData;

                return from(
                    deps.bannersDataProvider.getCreativesForEdit(login, ids)
                ).pipe(
                    mergeMap(
                        (creatives: BannerImageForEdit[]): Array<Action> => {
                            if (bannerId === MassActionId.bannersEdit) {
                                if (
                                    !validateImageCreativeItemsBySizeDuplicates(
                                        creatives
                                    )
                                ) {
                                    return [
                                        showBannerImageUploadError(bannerId, [
                                            {
                                                code:
                                                    'NO_DUPLICATE_MASS_ACTIONS',
                                                params: null,
                                                path: ''
                                            }
                                        ])
                                    ];
                                }

                                return [
                                    updateMassActionsImageCreative(
                                        MassActionId.bannersEdit,
                                        creatives
                                    ),
                                    updateBannerCanvasCreative(
                                        bannerId,
                                        creatives[0]
                                    )
                                ];
                            }

                            const { fixedSize } = state.imageEditor[
                                bannerId
                            ].image;

                            const banner = state.editBanners.banners[bannerId];

                            if (fixedSize && !banner.isNew) {
                                const sizeErrors = ImagesAdValidator.checkSize(
                                    creatives[0],
                                    fixedSize
                                );

                                if (sizeErrors.length > 0) {
                                    if (
                                        banner.bannerType === AdvType.IMAGE_AD
                                    ) {
                                        return [
                                            showBannerImageCreativeUploadError(
                                                bannerId,
                                                sizeErrors
                                            )
                                        ];
                                    } else {
                                        return [
                                            showBannerImageUploadError(
                                                bannerId,
                                                sizeErrors
                                            )
                                        ];
                                    }
                                }
                            }

                            const creativesForNewBanners = creatives.slice(1);

                            const groupId = banner.group.id;
                            const campaignId = banner.campaign.id;

                            const autoGeneratedVideo = mapGroupsDataToBannerVideoFormat(
                                state.editBanners.groupBannersList
                            );

                            return [
                                updateBannerCanvasCreative(
                                    bannerId,
                                    creatives[0]
                                ),
                                addNewTextBanners(
                                    creativesForNewBanners.map(() => ({
                                        campaignId,
                                        groupId,
                                        bannerType: AdvType.IMAGE_AD,
                                        bannerData: {
                                            id: generateNewBannerId(
                                                campaignId,
                                                groupId
                                            )
                                        }
                                    })),
                                    autoGeneratedVideo
                                ),
                                addImagesToNewBanners(creativesForNewBanners)
                            ];
                        }
                    ),
                    catchError((error: ApiMethodExecutingError) => {
                        return [
                            showBannerImageUploadError(
                                bannerId,
                                error.getErrors()
                            )
                        ];
                    })
                );
            }
        )
    );
};

const getPerformanceCreativesEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(FETCH_PERFORMANCE_CREATIVES_START),
        switchMap(
            (
                action: FetchPerformanceCreativesStartAction
            ): Observable<Action> => {
                const state = store$.value;
                const { login } = state.commonData;
                const { performanceCreatives, banners } = state.editBanners;
                const { limit, offset } = action;
                const {
                    modalData,
                    order,
                    searchFieldByIdOrName: idOrName
                } = performanceCreatives;

                if (!modalData) {
                    throw new Error(
                        'Данные для получения креативов отсутствуют'
                    );
                }

                const { groupId, campaignId } = modalData;

                return from(
                    deps.bannersDataProvider.getPerformanceCreatives({
                        login,
                        campaignId,
                        groupId,
                        limit,
                        offset,
                        order,
                        idOrName
                    })
                ).pipe(
                    mergeMap(
                        (response): Observable<Action> =>
                            of(
                                fetchPerformanceCreativesSuccess(
                                    mapPerformanceCreatives(
                                        response,
                                        banners,
                                        groupId
                                    )
                                )
                            )
                    ),
                    catchError(
                        (): Observable<Action> => {
                            return of(fetchPerformanceCreativesError());
                        }
                    )
                );
            }
        )
    );
};

const updatePerformanceCreativesSearchFieldEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = action$ => {
    return action$.pipe(
        ofType(PERFORMANCE_CREATIVES_CHANGE_ID_OR_NAME),
        debounceTime(300),
        map(
            (): Action =>
                fetchPerformanceCreativesStart(
                    DEFAULT_CREATIVES_LIMIT,
                    DEFAULT_CREATIVES_OFFSET
                )
        )
    );
};

const leavePerformanceBannerCreationEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(LEAVE_PERFORMANCE_BANNER_CREATION),
        mergeMap(
            (action: LeavePerformanceBannerCreation): Observable<Action> => {
                const { campaignId } = action;
                const url = UrlHelpers.getBannersListUrl();
                const {
                    commonData: { login, fromOldInterface }
                } = store$.value;

                const changeLocationAction = fromOldInterface
                    ? changeLocationHard(
                          UrlHelpers.getShowCampaignUrl(campaignId, login)
                      )
                    : changeLocation(
                          url,
                          {
                              ulogin: login
                          },
                          false
                      );

                // закрываем модалку смартов и уходим на грид кампаний
                return from([
                    setVisiblePerformanceChooseCreativesModal(false),
                    changeLocationAction
                ]);
            }
        )
    );
};

const updateProtocolDraftSiteLinksEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(UPDATE_PROTOCOL_DRAFT_SITE_LINKS),
        mergeMap(
            (action: UpdateProtocolDraftSiteLinks): Observable<Action> => {
                const { bannerId, index, value } = action;
                const siteLinksData =
                    store$.value.siteLinksEditor.data[action.bannerId];
                const link = siteLinksData.items[index].link || '';

                if (link.length === 0) {
                    return EMPTY;
                }

                if (!UrlHelpers.isUrlValid(value + link)) {
                    return of(
                        updateSiteLinkHrefStatus(
                            bannerId,
                            index,
                            false,
                            getEditBannerHrefValidateText(
                                HrefValidationStatuses.INVALID_VALUE
                            )
                        )
                    );
                } else {
                    return of(
                        checkBannerSitelinkHrefStatus(
                            bannerId,
                            index,
                            value + link
                        )
                    );
                }
            }
        )
    );
};

const handleBannersEditMassActionsEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(HANDLE_BANNERS_EDIT_MASS_ACTIONS),
        mergeMap(
            ({ action }: HandleBannersEditMassActions): Observable<Action> => {
                switch (action) {
                    case BannersEditMassActionItemType.link:
                        return of(
                            openMassActionsLinkBulkReplacementEditor(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.linkReplace:
                        return of(
                            openMassActionsLinkBulkPathReplacementEditor(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.visibleLinkReplace:
                        return of(
                            openMassActionsLinkDisplayedBulkReplacementEditor(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.textPathReplace:
                        return of(
                            openMassActionsTextBulkReplacementEditor(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.turbo:
                        return of(
                            openMassActionsTurbolandingBulkReplacementEditorAction(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.cpmImageCreative:
                        return of(
                            openMassActionsBulkCpmImageCreativeReplacementEditor(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.image:
                        return of(
                            openMassActionsBulkImageReplacementEditor(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.imageCreative:
                        return of(
                            openMassActionsBulkImageCreativeReplacementEditor(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.video:
                        return of(
                            openMassActionsVideoBulkReplacementEditorAction(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.audioCreative:
                        return of(
                            openMassActionsVideoCreativeBulkReplacementEditorAction(
                                MassActionId.bannersEdit,
                                AdvType.CPM_AUDIO
                            )
                        );
                    case BannersEditMassActionItemType.cpmVideoCreative:
                        return of(
                            openMassActionsVideoCreativeBulkReplacementEditorAction(
                                MassActionId.bannersEdit,
                                AdvType.CPM_VIDEO
                            )
                        );
                    case BannersEditMassActionItemType.videoCreative:
                        return of(
                            openMassActionsVideoCreativeBulkReplacementEditorAction(
                                MassActionId.bannersEdit,
                                AdvType.CPC_VIDEO
                            )
                        );
                    case BannersEditMassActionItemType.siteLinks:
                        return of(
                            onOpenMassActionsSiteLinksEditor(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.tracking:
                        return of(
                            openMassActionsTrackingParametersBulkReplacementEditor(
                                MassActionId.bannersEdit
                            )
                        );
                    case BannersEditMassActionItemType.bannerPrice:
                        return of(
                            openBannersPricesPopup(MassActionId.bannersEdit)
                        );

                    case BannersEditMassActionItemType.callouts:
                        return of(
                            openMassActionsCallouts(MassActionId.bannersEdit)
                        );
                    case BannersEditMassActionItemType.pixel:
                        return of(
                            openMassActionsPixel(MassActionId.bannersEdit)
                        );
                    case BannersEditMassActionItemType.counters:
                        return of(
                            openMassActionsCounters(MassActionId.bannersEdit)
                        );
                    case BannersEditMassActionItemType.ageLimit:
                    case BannersEditMassActionItemType.childAgeLimit:
                    case BannersEditMassActionItemType.visibleDomain:
                    default:
                        return of(dummyAction);
                }
            }
        )
    );
};

const onAddTextBannerEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(ON_ADD_NEW_TEXT_BANNER),
        mergeMap(
            (
                action: OnAddNewTextBanner
            ): Array<Action> | Observable<Action> => {
                const { banner } = action;
                const {
                    vCardsIds,
                    groupBannersList
                } = store$.value.editBanners;
                const vCardId = vCardsIds[banner.campaignId];
                const { login } = store$.value.commonData;
                banner.vCardId = vCardId;

                const autoGeneratedVideo = mapGroupsDataToBannerVideoFormat(
                    groupBannersList
                );
                const result: Array<Action> = [
                    addNewTextBanners([banner], autoGeneratedVideo)
                ];

                if (vCardId) {
                    result.push(getVCardsForBannersEdit(login, [vCardId]));
                }

                result.push(
                    initOrganizationsEditors([
                        {
                            editorKey: mapEntityIdToEditorKey(
                                banner.bannerData.id,
                                EntityType.banner
                            ),
                            organizationId: undefined
                        }
                    ])
                );

                return result;
            }
        )
    );
};

const createNewTextBannerEpic: DnaEpic = action$ => {
    return action$.pipe(
        ofType(CREATE_NEW_TEXT_BANNER),
        map(
            (action: CreateNewTextBannerAction): Action =>
                initOrganizationsEditors([
                    {
                        editorKey: mapEntityIdToEditorKey(
                            action.bannerId,
                            EntityType.banner
                        ),
                        organizationId: undefined
                    }
                ])
        )
    );
};

const getBannersAutoGeneratedVideosEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(GET_BANNERS_AUTO_GENERATED_VIDEO),
        mergeMap(
            (action: GetBannersAutoGeneratedVideo): Observable<Action> => {
                return from(
                    deps.bannersMutationExecutor.getGeneratedTextVideo({
                        adGroupIds: action.groupsIds
                    })
                ).pipe(
                    mergeMap(
                        (result): Observable<Action> => {
                            if (
                                result &&
                                result.generateVideoAddition &&
                                result.generateVideoAddition.length !== 0 &&
                                result.generateVideoAddition[0]
                            ) {
                                const {
                                    groupBannersList,
                                    banners
                                } = store$.value.editBanners;
                                const { video } = store$.value;
                                const newVideoGroupState = mapGeneratedVideoGroupApiFormat(
                                    result.generateVideoAddition,
                                    action.groupsIds
                                );
                                const newBannersWithVideoState = mapVideoGroupsToBannerFormat(
                                    newVideoGroupState,
                                    groupBannersList,
                                    banners
                                );
                                const newVideoState = {
                                    ...video,
                                    ...newBannersWithVideoState
                                };

                                return from([
                                    updateBannersAutoGeneratedVideo(
                                        newVideoGroupState
                                    ),
                                    updateVideos(newVideoState)
                                ]);
                            }

                            return EMPTY;
                        }
                    ),
                    catchError(error => {
                        return of(updateBannersAutoGeneratedVideo({}));
                    })
                );
            }
        )
    );
};

const prepareBannersBeforeSavingEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(PREPARE_BANNERS_BEFORE_SAVING),
        mergeMap(
            (): Observable<Action> => {
                const state = store$.value;
                const {
                    commonData: { login },
                    editBanners,
                    bannersPriceEditor,
                    siteLinksEditor
                } = store$.value;
                const banners = state.editBanners.banners as Record<
                    BannerId,
                    EditedBanner
                >;
                const draftBanners = state.editBanners.bannersDraft;

                const {
                    siteLinksBannersIds,
                    siteLinksEmptyBannersIds,
                    bannerPricesBannersIds,
                    calloutsEditorIds,
                    bannerPricesEmptyIds
                } = getGroupedBannersIdsByOpenCard(
                    banners,
                    draftBanners,
                    siteLinksEditor.data,
                    bannersPriceEditor
                );

                const requestDataForBannerPrices = bannerPricesBannersIds.map(
                    id => state.bannersPriceEditor[id].bannerPrice
                );
                const workCurrency = state.editBanners.clientInfo.workCurrency;

                const bannersIds = getTextBannersIds(banners);

                const {
                    bannerIdsIsNeedForUpdatingVisitingCard,
                    bannerIdsIsEmptyForUpdatingVisitingCard
                } = getGroupedBannersIdsForVisitingCard(state, bannersIds);

                const availableBanners = bannersIds.reduce(
                    (acc: EditedBannerTypeText[], id) => {
                        const availableBanner = getEditedBannerMassSaveActions(
                            banners[id]
                        );
                        if (availableBanner !== undefined) {
                            acc.push(availableBanner);
                        }
                        return acc;
                    },
                    []
                );

                const openedOrganizationEditorParams: OrganizationEditorParams[] = bannersIds
                    .filter(
                        bannerId =>
                            state.organizationsEditor[
                                mapEntityIdToEditorKey(
                                    bannerId,
                                    EntityType.banner
                                )
                            ].isOpen
                    )
                    .map(bannerId => {
                        const editorKey = mapEntityIdToEditorKey(
                            bannerId,
                            EntityType.banner
                        );
                        const editor = state.organizationsEditor[editorKey];
                        return {
                            editorKey,
                            organizationId: editor.organizationId
                        };
                    });

                const collapsedSiteLinksInOpenEditors = siteLinksBannersIds.map(
                    bannerId =>
                        getCollapsedSiteLinks(
                            siteLinksEditor.data[bannerId].items
                        )
                );

                const availableSiteLinksData = bannersIds.map(
                    (bannerId, index) => {
                        const siteLinks = { ...siteLinksEditor.data[bannerId] };
                        const indexInCollapsedSiteLinks = siteLinksBannersIds.indexOf(
                            bannerId
                        );

                        if (indexInCollapsedSiteLinks !== -1) {
                            siteLinks.items =
                                collapsedSiteLinksInOpenEditors[
                                    indexInCollapsedSiteLinks
                                ];
                        }

                        return siteLinks;
                    }
                );

                if (
                    !availableBanners.length ||
                    (!siteLinksBannersIds.length &&
                        !siteLinksEmptyBannersIds.length &&
                        !bannerPricesEmptyIds.length &&
                        !bannerPricesBannersIds.length &&
                        !calloutsEditorIds.length &&
                        !bannerIdsIsNeedForUpdatingVisitingCard.length &&
                        !bannerIdsIsEmptyForUpdatingVisitingCard.length &&
                        !openedOrganizationEditorParams.length)
                ) {
                    return of(saveBanners());
                }

                const validateSitelinksResultForOpenEditors: ValidationResultItem[][] = validateSiteLinks(
                    availableBanners,
                    availableSiteLinksData,
                    siteLinksBannersIds,
                    editBanners
                );
                const isClientValidationEmpty = validateSitelinksResultForOpenEditors.every(
                    item => item.length === 0
                );

                if (!isClientValidationEmpty) {
                    return of(
                        showSiteLinksErrors(
                            siteLinksBannersIds,
                            collapsedSiteLinksInOpenEditors,
                            validateSitelinksResultForOpenEditors
                        )
                    );
                }

                const newSiteLinks = mapBannersSiteLinksToApiFormat(
                    siteLinksBannersIds,
                    siteLinksEditor.data
                );

                const requestDataForSiteLinks: GdAddSitelinkSetsInput = {
                    sitelinkSetsAddItems: newSiteLinks
                };

                const requestDataForVCard: GdAddVcardsInput = {
                    vcardAddItems: bannerIdsIsNeedForUpdatingVisitingCard.map(
                        bannerId => {
                            const campaignId = banners[bannerId].campaign.id;
                            const visitingCardEditorId = getBannerEditPageItemEditorId(
                                bannerId
                            );
                            const currentVisitingCardEditor = selectVisitingCardEditorValue(
                                state,
                                visitingCardEditorId
                            );
                            const currentVisitingCardValue = mapVisitingCardEditorValueToValue(
                                currentVisitingCardEditor
                            );

                            return mapVCardToApiFormat(
                                currentVisitingCardValue,
                                campaignId
                            );
                        }
                    )
                };

                const validateBannerPricePromise =
                    bannerPricesBannersIds.length === 0
                        ? Promise.resolve()
                        : deps.bannersDataProvider.validateBannerPrice(
                              requestDataForBannerPrices
                          );
                const addVCardsPromise =
                    bannerIdsIsNeedForUpdatingVisitingCard.length === 0
                        ? Promise.resolve()
                        : deps.bannersMutationExecutor.addVCards(
                              requestDataForVCard
                          );
                const addSiteLinkSetPromise =
                    siteLinksBannersIds.length === 0
                        ? Promise.resolve()
                        : deps.sitelinksMutationExecutor.addSitelinkSet(
                              requestDataForSiteLinks,
                              login
                          );

                return from(
                    Promise.all<
                        ApolloQueryResult<validateAdPrice> | void,
                        FetchResult<AddVCards> | void,
                        FetchResult<AddSitelinkSets> | void
                    >([
                        validateBannerPricePromise,
                        addVCardsPromise,
                        addSiteLinkSetPromise
                    ])
                ).pipe(
                    mergeMap(
                        ([
                            bannersPriceResult,
                            vCardResult,
                            siteLinksResult
                        ]): Observable<Action> => {
                            const updateAction$ = [];

                            if (bannersPriceResult) {
                                updateAction$.push(
                                    of(
                                        ...getBannerPricePromiseValidateActions(
                                            bannerPricesBannersIds,
                                            bannersPriceResult,
                                            workCurrency
                                        )
                                    )
                                );
                            }

                            if (vCardResult) {
                                updateAction$.push(
                                    of(
                                        ...getVCardsPromiseSaveActions(
                                            bannerIdsIsNeedForUpdatingVisitingCard,
                                            vCardResult
                                        )
                                    )
                                );
                            }

                            if (siteLinksResult) {
                                updateAction$.push(
                                    of(
                                        ...getSiteLinksPromiseSaveActions(
                                            siteLinksBannersIds,
                                            newSiteLinks,
                                            login,
                                            siteLinksResult,
                                            collapsedSiteLinksInOpenEditors
                                        )
                                    )
                                );
                            }

                            if (calloutsEditorIds.length) {
                                updateAction$.push(
                                    of(saveCallouts(calloutsEditorIds))
                                );
                            }

                            if (siteLinksEmptyBannersIds.length) {
                                updateAction$.push(
                                    of(clearSiteLinks(siteLinksEmptyBannersIds))
                                );
                            }

                            if (
                                bannerIdsIsEmptyForUpdatingVisitingCard.length
                            ) {
                                updateAction$.push(
                                    of(
                                        clearVCard(
                                            bannerIdsIsEmptyForUpdatingVisitingCard.map(
                                                getBannerEditPageItemEditorId
                                            )
                                        ),
                                        clearVisitingCardForEditBanners(
                                            bannerIdsIsEmptyForUpdatingVisitingCard
                                        )
                                    )
                                );
                            }

                            if (bannerPricesEmptyIds.length) {
                                updateAction$.push(
                                    of(
                                        validateBannerPriceSuccess(
                                            bannerPricesEmptyIds,
                                            workCurrency
                                        )
                                    )
                                );
                            }

                            if (openedOrganizationEditorParams.length) {
                                updateAction$.push(
                                    of(
                                        updateBannersOrganizationIds(
                                            openedOrganizationEditorParams
                                        )
                                    )
                                );
                            }

                            return concat(...updateAction$, of(saveBanners()));
                        }
                    ),
                    catchError(
                        (err): Observable<Action> => {
                            const bannersPriceObservable$ = of(
                                ...getBannerPricePromiseErrorActions(
                                    bannerPricesBannersIds
                                )
                            );
                            const vCardObservable$ = of(
                                ...getVCardsPromiseErrorActions(
                                    bannerIdsIsNeedForUpdatingVisitingCard
                                )
                            );
                            const siteLinksObservable$ = of(
                                ...getSiteLinksPromiseErrorActions(
                                    err,
                                    siteLinksBannersIds,
                                    collapsedSiteLinksInOpenEditors,
                                    newSiteLinks,
                                    login
                                )
                            );

                            return concat(
                                bannersPriceObservable$,
                                vCardObservable$,
                                siteLinksObservable$,
                                of(saveBanners())
                            );
                        }
                    )
                );
            }
        )
    );
};

const fetchGroupKeywordsAndRetargetingsEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(ON_START_LOAD_KEYWORDS_AND_RETARGENTING_DISPLAY_CONDITIONS),
        mergeMap(
            (
                action: OnStartLoadKeywordsAndRetargetingDisplayConditions
            ): Observable<Action> => {
                return from(
                    deps.groupsDataProvider.getKeywordsAndRetargetings(
                        store$.value.commonData.login,
                        [action.groupId],
                        [action.campaignId]
                    )
                ).pipe(
                    mergeMap(
                        (result): Observable<Action> => {
                            return of(
                                onLoadKeywordsAndRetargetingDisplayConditions(
                                    action.id,
                                    result.keywords,
                                    result.retargeting
                                )
                            );
                        }
                    ),
                    catchError(
                        (): Observable<Action> => {
                            showNoticeMessage(
                                NoticeType.error,
                                i18n('error-display-conditions')
                            );
                            return of(
                                onErrorLoadKeywordsAndRetargetingDisplayConditions(
                                    action.id
                                )
                            );
                        }
                    )
                );
            }
        )
    );
};

const changeOpenStateDisplayConditionsEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$.pipe(
        ofType(ON_CHANGE_OPEN_STATE_DISPLAY_CONDITIONS),
        mergeMap(
            (
                action: OnChangeOpenStateDisplayConditions
            ): Observable<Action> => {
                const editedBanner =
                    store$.value.editBanners.banners[action.id];
                if (
                    bannerHasDisplayConditions(editedBanner) &&
                    !editedBanner.displayConditions.isLoading &&
                    (editedBanner.displayConditions.retargeting === undefined ||
                        editedBanner.displayConditions.keywords === undefined)
                ) {
                    return of(
                        onStartLoadKeywordsAndRetargetingDisplayConditions(
                            action.id,
                            action.groupId,
                            action.campaignId
                        )
                    );
                }

                return EMPTY;
            }
        )
    );
};

const copyKeywordsToClipboardEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(COPY_KEYWORDS_TO_CLIPBOARD),
        mergeMap(
            (action: CopyKeywordsToClipboard): Observable<Action> => {
                return from(copyTextToClipboard(action.text)).pipe(
                    mergeMap(
                        (): Observable<Action> => {
                            return of(
                                changeCopiedDisplayConditionsTooltipStatus(
                                    action.id,
                                    CopyTooltipStatus.success
                                )
                            );
                        }
                    ),
                    catchError(
                        (): Observable<Action> => {
                            return of(
                                changeCopiedDisplayConditionsTooltipStatus(
                                    action.id,
                                    CopyTooltipStatus.error
                                )
                            );
                        }
                    )
                );
            }
        )
    );
};

const COPIED_TOOLTIP_TIMEOUT = 1000;

const changeCopiedDisplayConditionsTooltipStatusEpic: DnaEpic = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(CHANGE_COPIED_DISPLAY_CONDITIONS_TOOLTIP_STATUS),
        mergeMap(
            (
                action: ChangeCopiedDisplayConditionsTooltipStatus
            ): Observable<ChangeCopiedDisplayConditionsTooltipStatus> => {
                const { newStatus } = action;

                if (newStatus === CopyTooltipStatus.hidden) {
                    return EMPTY;
                }

                return of(
                    changeCopiedDisplayConditionsTooltipStatus(
                        action.id,
                        CopyTooltipStatus.hidden
                    )
                ).delay(COPIED_TOOLTIP_TIMEOUT);
            }
        )
    );
};

export const changeBannerTypeAttemptEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$) => {
    return action$.pipe(
        ofType(CHANGE_BANNER_TYPE_ATTEMPT),
        switchMap(
            (action: ChangeBannerTypeAttempt): Observable<Action> => {
                const state = store$.value;
                const {
                    editBanners: { banners }
                } = state;
                const bannerType = banners[action.bannerId].bannerType;

                const result: Action[] = [
                    changeBannerType(action.bannerId, action.bannerType)
                ];

                if (bannerType === action.bannerType) {
                    return EMPTY;
                }

                const isAdvSubtypeSwitching =
                    (bannerType === AdvType.TEXT &&
                        action.bannerType === AdvTypeClient.TEXT_MOBILE) ||
                    (bannerType === AdvTypeClient.TEXT_MOBILE &&
                        action.bannerType === AdvType.TEXT);

                if (!isAdvSubtypeSwitching) {
                    result.push(bannerImageRemove(action.bannerId));
                    result.push(bannerVideoRemove(action.bannerId));
                }

                return from(result);
            }
        )
    );
};

const saveVisitingCardForEditBannerEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(SAVE_VISITING_CARD_FOR_EDIT_BANNER),
        mergeMap(
            (action: SaveVisitingCardForEditBanner): Observable<Action> => {
                const state = store$.value;
                const {
                    visitingCardEditor,
                    editBanners: { banners }
                } = state;
                const { bannerIds } = action;

                const {
                    bannerIdsIsNeedForUpdatingVisitingCard,
                    bannerIdsIsEmptyForUpdatingVisitingCard
                } = getGroupedBannersIdsForVisitingCard(state, bannerIds);

                const clearActions = [
                    clearVCard(
                        bannerIdsIsEmptyForUpdatingVisitingCard.map(
                            getBannerEditPageItemEditorId
                        )
                    ),
                    clearVisitingCardForEditBanners(
                        bannerIdsIsEmptyForUpdatingVisitingCard
                    )
                ];

                if (
                    bannerIds.length ===
                    bannerIdsIsEmptyForUpdatingVisitingCard.length
                ) {
                    return from(clearActions);
                }

                const requestData: GdAddVcardsInput = {
                    vcardAddItems: [
                        ...bannerIdsIsNeedForUpdatingVisitingCard.map(
                            bannerId => {
                                const editorId = getBannerEditPageItemEditorId(
                                    bannerId
                                );
                                const currentBanner = banners[bannerId];
                                const visitingCardEditorValue =
                                    visitingCardEditor[editorId];
                                const visitingCardValue = mapVisitingCardEditorValueToValue(
                                    visitingCardEditorValue
                                );

                                return mapVCardToApiFormat(
                                    visitingCardValue,
                                    currentBanner.campaign.id
                                );
                            }
                        )
                    ]
                };

                return from(
                    deps.bannersMutationExecutor.addVCards(requestData)
                ).pipe(
                    mergeMap(
                        (
                            result: ApolloQueryResult<AddVCards>
                        ): Observable<Action> => {
                            return of(
                                ...getVCardsPromiseSaveActions(
                                    bannerIds,
                                    result
                                ),
                                ...clearActions
                            );
                        }
                    ),
                    catchError(
                        (): Observable<Action> => {
                            return of(
                                ...getVCardsPromiseErrorActions(bannerIds),
                                ...clearActions
                            );
                        }
                    )
                );
            }
        )
    );
};

const clearBannersForEditBannerEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(CLEAR_BANNERS),
        switchMap(
            (action: ClearBanners): Observable<Action> => {
                const state = store$.value;
                const { visitingCardEditor } = state;
                // TODO DIRECT-104026 - разнести всё на разные экшены
                const { bannersToClear } = action;
                const editorIds = Object.keys(bannersToClear).reduce(
                    (acc: string[], bannerId: BannerId) => {
                        const editorId = getBannerEditPageItemEditorId(
                            bannerId
                        );

                        if (Boolean(visitingCardEditor[editorId])) {
                            acc.push(editorId);
                        }

                        return acc;
                    },
                    []
                );

                if (editorIds.length === 0) {
                    return EMPTY;
                }

                return of(clearVCard(editorIds));
            }
        )
    );
};

export {
    changeCopiedDisplayConditionsTooltipStatusEpic,
    changeOpenStateDisplayConditionsEpic,
    copyKeywordsToClipboardEpic,
    fetchGroupKeywordsAndRetargetingsEpic,
    getBannersForEditEpic,
    getRecommendationsForBannersEditEpic,
    openRecommendationsModalForBannersEditEpic,
    getBaseInfoForBannerCreationEpic,
    getVCardsForEditEpic,
    getImagesForEdit,
    scrollToDuplicateBannerEpic,
    clearOrganizationsBannersEpic,
    copyOrganizationBannerEpic,
    checkBannersPromocodesEpic,
    saveBannersEpic,
    uploadBannerImageEpic,
    prepareBannersBeforeSavingEpic,
    uploadTextBannerImageByLinkEpic,
    createNewBannerEpic,
    cancelBannersEpic,
    getTurbolandingInfoEpic,
    getTurbolandingInfoForSitelinkEpic,
    updateDraftSiteLinksEpic,
    updateBannersContactsForUserEpic,
    onVideoCreativeCloseEpic,
    updateCpmBannerCreativeIdEpic,
    updateBannerCreativeIdEpic,
    updateBannerCpcCreativeIdEpic,
    saveSitelinksEpic,
    checkBannerHrefStatusEpic,
    checkBannerSitelinkHrefStatusEpic,
    getImageCanvasForEdit,
    uploadAdBannerImagesEpic,
    uploadAdBannerImageByLinkEpic,
    validateBannerPriceEpic,
    validateAdBannerImagesEpic,
    updateBannerImagesFromGallery,
    showBannerImagesErrorEpic,
    validateBannerImageFromGalleryEpic,
    leaveBannersEditEpic,
    handleBannersEditMassActionsEpic,
    updatePerformanceCreativesSearchFieldEpic,
    leavePerformanceBannerCreationEpic,
    getPerformanceCreativesEpic,
    updateLinkProtocolBannersContactsForUserEpic,
    updateProtocolDraftSiteLinksEpic,
    createNewTextBannerEpic,
    onAddTextBannerEpic,
    updateBannersContactsForUserDomainEpic,
    getModerationRejectReasons,
    getBannersAutoGeneratedVideosEpic,
    saveVisitingCardForEditBannerEpic,
    clearBannersForEditBannerEpic,
    fetchVCardMetroStationEpic
};
